// ---------------------------------------------------------------------------
// Woerterbuch Deutsch / Englisch — ERZEUGT, nicht von Hand gepflegt
//
// Die Schluessel stehen als data-i18n / data-i18n-html /
// data-i18n-platzhalter / data-i18n-titel / data-i18n-aria im Markup und
// wurden mit einem Werkzeug gesetzt, das die HTML-Dateien nur um genau
// dieses eine Attribut ergaenzt (Formatierung sonst unveraendert).
//
// AUFBAU DER SCHLUESSEL
//   <quelle>.<laufende nummer>   z. B. "app.042", "501game.007"
// Die Quelle ist der Dateiname: app = index.html, 501 = partials/501.html,
// 501game = partials/501-game.html, dazu stats, kontakt, admin, impressum,
// datenschutz. Die alten, von Hand vergebenen Schluessel (einst.*, caller.*)
// stehen unveraendert am Anfang.
//
// WAS HIER NICHT STEHT
// Texte, die JavaScript erzeugt (Toasts, "Gegner wirft ...", die
// Statistikseite), tragen eigene sprechende Schluessel — sie werden im
// Code ueber t() geholt und stehen weiter unten im js-Block.
//
// WAS ABSICHTLICH GLEICH BLEIBT
// Marke ("Secure Darts"), Modusnamen (Cricket, Gotcha, RTW), feststehende
// Darts-Rufe ("Game Shot!", "Bull") und Kuerzel auf Knoepfen (OK, DEL).
// Sie tragen erst gar keinen Schluessel.
// ---------------------------------------------------------------------------

const TEXTE = {
  de: {

    // ── Aufnahme-Eingabe (aufnahme-eingabe.js, 14.08.2026) ──────
    // Die Zeile ueber dem Board. Je Modus steht dort eine andere
    // Groesse: Punkte (X01), Treffer (Bob's, RTW) oder Rest (Random).
    "aufnahme.treffer": "Treffer",
    "aufnahme.rest": "Rest",
    "aufnahme.ziel": "Ziel",
    "aufnahme.dartsUebrig": "{p1} von {p2} Darts",
    "aufnahme.gecheckt": "Gecheckt mit {p1} Darts",
    "aufnahme.ueberworfen": "Überworfen",
    "aufnahme.nichtGeschafft": "Nicht geschafft",
    // Korrektur eines vom Tracker erkannten Darts (15.08.2026)
    "aufnahme.korrekturHinweis": "Erkannten Dart antippen, um ihn zu korrigieren",
    "aufnahme.korrekturFeld": "Neues Feld für Dart {p1} wählen",
    // Double-Out als Option (15.08.2026)
    "party.bustDoppel": "{p1}: Kein Doppel zum Finish – Bust!",
    "gotcha.bustDoppel": "{p1}: Zielzahl nur mit Doppel – Bust!",
    "party.009": "Double-Out",
    "party.010": "Finish nur mit Doppel oder Bullseye",
    "gotcha.012": "Double-Out",
    "gotcha.013": "Zielzahl nur mit Doppel oder Bullseye",
    // Bull-Off (15.08.2026)
    "bulloff.titel": "Bull-Off",
    "einst.paketStandard": "Standard",
    // Admin-Archiv (15.08.2026)
    "admin.offen": "Offen",
    "admin.archiv": "Archiv",
    "js.admin.erledigt": "Erledigt",
    "js.admin.zurueckholen": "Zurückholen",
    "js.admin.archiviert": "Nachricht archiviert",
    "js.admin.zurueckgeholt": "Nachricht wieder offen",
    "js.admin.archivFehlt": "Archiv nicht verfügbar – bitte supabase/contact_messages_archiv.sql ausführen.",
    "bulloff.dran": "{p1} wirft auf das Bull",
    "bulloff.wartet": "Warte auf {p1}…",
    "bulloff.fertig": "Entschieden",
    "bulloff.daneben": "daneben",
    "bulloff.gleichstand": "Gleichstand – noch einmal!",
    "bulloff.beginnt": "{p1} beginnt",
    "bulloff.abbrechen": "Ohne Bull-Off starten",
    "501.bulloffLabel": "Bull-Off",
    "501.bulloffText": "Wer näher am Bull ist, fängt an",
    "cricket.bulloffLabel": "Bull-Off",
    "cricket.bulloffText": "Wer näher am Bull ist, fängt an",

    // ── caller ──────────────────────────────────────────────────
    "caller.bust": "Bust",
    "caller.gameShot": "Game shot",
    "caller.match": "Match",
    "caller.youRequire": "Du brauchst",

    // ── einst ───────────────────────────────────────────────────
    "einst.titel": "Einstellungen",
    "einst.zurueck": "Zurück",
    "einst.konto": "Konto",
    "einst.email": "E-Mail-Adresse",
    "einst.passwort": "Neues Passwort",
    "einst.passwortPlatzhalter": "Mindestens 6 Zeichen",
    "einst.speichern": "Speichern",
    "einst.darstellung": "Darstellung",
    "einst.groesse": "Anzeigegröße",
    "einst.akzent": "Akzentfarbe",
    "einst.akzentHinweis": "Färbt Fokusrahmen und aktive Auswahlen in der ganzen App.",
    "einst.sprache": "Sprache",
    "einst.spracheHinweis": "Stellt die Oberfläche um. Der Caller spricht die Sprache seiner Aufnahmen.",
    "einst.geraet": "Gerät koppeln",
    "einst.geraetHinweis": "Erzeuge einen Code, um dich auf dem Gerät eines Freundes als Gast anzumelden. Deine Statistiken werden trotzdem gespeichert.",
    "einst.pairing": "Pairing-Code erzeugen",
    "einst.caller": "Caller",
    "einst.callerHinweis": "Sagt jeden gewerteten Wurf an. Gesprochen werden eigene Aufnahmen; fehlt eine, wird sie aus vorhandenen zusammengesetzt.",
    "einst.callerAn": "Caller aktivieren",
    "einst.paket": "Stimmen-Paket",
    "einst.paketHinweis": "Zurzeit ist eine Stimme aufgenommen. Weitere folgen.",
    "einst.rueckfall": "Fehlende Aufnahmen durch Systemstimme ersetzen",
    "einst.systemstimme": "Systemstimme (nur für den Rückfall)",
    "einst.stimmeAuto": "Automatisch",
    "einst.lautstaerke": "Lautstärke",
    "einst.tempo": "Sprechtempo",
    "einst.wasAngesagt": "Was angesagt wird",
    "einst.punkte": "Geworfener Score",
    "einst.rest": "Rest ab 170 statt Score („you require 170“)",
    "einst.bust": "Bust",
    "einst.spielende": "Game shot und Match",
    "einst.testen": "Ansage testen",
    "einst.erweitert": "Erweitert",
    "einst.streamer": "Streamer-Modus (Bereichs-Zoom)",
    "einst.wennDateiFehlt": "Wenn eine Aufnahme fehlt",
    "einst.obs": "OBS-Streaming",
    "einst.obsHinweis": "Schaltet in OBS (ab v28) automatisch auf eine Checkout-Szene, sobald <strong>du selbst</strong> ein Feld anvisierst — Rest gerade und höchstens 40, oder 50 auf Bullseye. Der Rest des Gegners zählt nicht: Er wirft auf sein eigenes Board. OBS muss auf demselben Rechner laufen.",
    "einst.obsAn": "Szenenwechsel aktivieren",
    "einst.port": "Port",
    "einst.obsPasswort": "Server-Passwort",
    "einst.obsPasswortPlatzhalter": "aus den OBS-WebSocket-Einstellungen",
    "einst.szeneCheckout": "Checkout-Szene",
    "einst.szeneStandard": "Standard-Szene",
    "einst.bereiche": "Streamer-Modus: Szene je Board-Bereich",
    "einst.bereicheHinweis": "Wählt die Szene, in der das anvisierte Doppel liegt — D20 oben, D3 unten, Bullseye Mitte. Leeres Feld fällt auf die Checkout-Szene zurück.",
    "einst.oben": "Oben — 20, 1, 18, 12, 5",
    "einst.rechts": "Rechts — 4, 13, 6, 10, 15",
    "einst.unten": "Unten — 2, 17, 3, 19, 7",
    "einst.links": "Links — 16, 8, 11, 14, 9",
    "einst.mitte": "Mitte — Bull und Bullseye",
    "einst.gefahr": "Konto löschen",
    "einst.gefahrHinweis": "Entfernt dein Konto und alle Statistiken. Das lässt sich nicht rückgängig machen.",
    "einst.loeschen": "Konto unwiderruflich löschen",
    "einst.gespeichert": "Einstellungen gespeichert.",

    // ── app ─────────────────────────────────────────────────────
    "app.001": "Willkommen",
    "app.002": "Melde dich an, um deine Statistiken geräteübergreifend und sicher zu speichern.",
    "app.003": "Passwort vergessen?",
    "app.004": "Einloggen",
    "app.005": "Account erstellen",
    "app.006": "Oder",
    "app.007": "Als Gast fortfahren (Lokal)",
    "app.008": "Impressum",
    "app.009": "Datenschutzerklärung",
    "app.010": "Menü",
    "app.011": "Hauptmenü",
    "app.012": "Offene Lobbies",
    "app.013": "Statistiken",
    "app.014": "Mein Profil",
    "app.015": "Impressum",
    "app.016": "Datenschutz",
    "app.017": "Kontakt",
    "app.018": "Beta-Hinweis anzeigen",
    "app.019": "Freunde",
    "app.020": "Suchen",
    "app.021": "Meine Freunde",
    "app.022": "Lade Freunde...",
    "app.023": "Wähle deinen Modus",
    "app.024": "Lokal oder Online Multiplayer",
    "app.025": "Taktisches Punkte-Sichern",
    "app.026": "Der absolute Klassiker",
    "app.027": "Bis zu 8 Spieler (Lokal)",
    "app.028": "Das Doppel-Training",
    "app.029": "ROUND THE <span style=\"color: var(--accent)\">WORLD</span>",
    "app.030": "WORLD",
    "app.031": "Einmal um das ganze Board",
    "app.032": "Catch <span style=\"color: var(--accent)\">121</span>",
    "app.033": "Level für Level nach oben",
    "app.034": "Cricket &<span style=\"color: var(--accent)\"> Tactics</span>",
    "app.035": "Tactics",
    "app.036": "Felder schließen und punkten",
    "app.037": "<span style=\"color: var(--accent)\">RANDOM</span> CHECKOUT",
    "app.038": "RANDOM",
    "app.039": "Zufallszahl in X Darts checken",
    "app.040": "GOT<span style=\"color: var(--accent)\">CHA</span>",
    "app.041": "Hochzählen Punkte klauen",
    "app.042": "SCORING <span style=\"color: var(--accent)\">TRAINING</span>",
    "app.043": "TRAINING",
    "app.044": "Open End werfen, Average sehen",
    "app.045": "Alle Modi anzeigen",
    "bot.stufe.neuling": "Neuling",
    "bot.stufe.anfaenger": "Anfänger",
    "bot.stufe.hobby": "Hobby",
    "bot.stufe.freizeit": "Freizeit",
    "bot.stufe.verein": "Vereinsspieler",
    "bot.stufe.liga": "Liga",
    "bot.stufe.ambitioniert": "Ambitioniert",
    "bot.stufe.profi": "Profi",
    "bot.stufe.halbprofi": "Halbprofi",
    "bot.stufe.weltklasse": "Weltklasse",
    "bot.stufe.nuke": "THE NUKE",
    "app.131": "Spielen",
    "app.132": "Gegeneinander, lokal oder online",
    "app.133": "Training",
    "app.134": "Allein oder zu mehreren üben",
    "app.046": "⬇ Tracker-Software",
    "app.047": "Geschlossener Alpha-Test – Zugang über das Kontaktformular",
    "app.048": "Zurück",
    "app.049": "EDIT",
    "app.050": "Spieler",
    "app.051": "Name ändern",
    "app.052": "Offene <span style=\"color: var(--accent)\">Lobbies</span>",
    "app.053": "Lobbies",
    "app.054": "Laufende 501-Räume zum direkten Beitreten",
    "app.055": "Lade Lobbies...",
    "app.056": "Aktualisieren",
    "app.057": "Zurück zum Hauptmenü",
    "app.058": "<b>Work-In-Progress:</b> Es handelt sich um ein aktives Projekt. Bitte meldet Bugs oder Wünsche über unser <a href=\"kontakt.html\">Kontaktformular</a> oder über unseren <a href=\"https://discord.gg/B4A3MZGjBa\">Discord</a>.",
    "app.059": "Work-In-Progress:",
    "app.060": "Kontaktformular",
    "app.061": "Discord",
    "app.062": "EDIT",
    "app.063": "501 Stats",
    "app.064": "Secure Stats",
    "app.065": "Bob's Stats",
    "app.066": "RTW Stats",
    "app.067": "Gesamt",
    "app.068": "Verlauf",
    "app.069": "DURCHSCHNITT PRO ZAHL",
    "app.070": "Bot Setup",
    "app.071": "Wähle den Ziel-Average des Bots:",
    "app.072": "Abbrechen",
    "app.073": "Startklar!",
    "app.074": "Spiel abbrechen?",
    "app.075": "Dein Fortschritt geht verloren.",
    "app.076": "Ja, abbrechen",
    "app.077": "Nein, weiterspielen",
    "app.078": "Abbrechen",
    "app.079": "Achtung!",
    "app.080": "Ja, bestätigen",
    "app.081": "Abbrechen",
    "app.082": "Spieler",
    "app.083": "Lade Statistiken…",
    "app.084": "Schließen",
    "app.085": "Statistik",
    "app.086": "Performance Graph",
    "app.087": "Spiel-Einstellungen",
    "app.088": "Modus:",
    "app.089": "301 Darts",
    "app.090": "501 Darts",
    "app.091": "701 Darts",
    "app.092": "Länge (Best of):",
    "app.093": "1 Leg",
    "app.094": "3 Legs",
    "app.095": "5 Legs",
    "app.096": "7 Legs",
    "app.097": "9 Legs",
    "app.098": "Herausfordern!",
    "app.099": "Abbrechen",
    "app.100": "Gast verifizieren",
    "app.101": "Gib den 6-stelligen Code des Spielers ein:",
    "app.102": "Verifizieren",
    "app.103": "Abbrechen",
    "app.104": "Wurf korrigieren",
    "app.105": "Single",
    "app.106": "Double",
    "app.107": "Triple",
    "app.108": "Abbrechen",
    "app.109": "E-Mail Adresse",
    "app.110": "Passwort (min. 6 Zeichen)",
    "app.111": "Menü öffnen",
    "app.112": "Einstellungen",
    "app.113": "Einstellungen öffnen",
    "app.114": "Freunde online",
    "app.115": "Nach Spielername suchen...",
    "app.116": "Profilbild ändern",
    "app.117": "Durchschnitt aus allen 501-Partien",
    "app.118": "Hinweis ausblenden",
    "app.119": "Profilbild ändern",
    "app.120": "Einstellungen öffnen",
    "app.121": "Schließen",
    "app.122": "Schließen",

    // ── stats ───────────────────────────────────────────────────
    "stats.001": "Secure Darts – Meine Statistiken",
    "stats.002": "MEINE STATISTIKEN",
    "stats.003": "Bitte logge dich ein, um deine Statistiken zu sehen.",
    "stats.004": "Zum Login",
    "stats.005": "Partien gesamt",
    "stats.006": "Modi gespielt",

    // ── kontakt ─────────────────────────────────────────────────
    "kontakt.001": "Kontakt - Secure-Darts",
    "kontakt.002": "KONTAKT",
    "kontakt.003": "Hast du Fragen oder Feedback? Schreib uns direkt.",
    "kontakt.004": "Du bist nicht eingeloggt. Du kannst uns trotzdem schreiben — gib dafür bitte deine E-Mail-Adresse an. <a href=\"/\" class=\"notice-link\">Zum Login</a>",
    "kontakt.005": "Zum Login",
    "kontakt.006": "Name (optional)",
    "kontakt.007": "E-Mail *",
    "kontakt.008": "Kategorie",
    "kontakt.009": "Allgemeine Anfrage",
    "kontakt.010": "Feedback / Ideen",
    "kontakt.011": "Wichtiges Anliegen",
    "kontakt.012": "Technischer Fehler",
    "kontakt.013": "Nachricht *",
    "kontakt.014": "NACHRICHT SENDEN",
    "kontakt.015": "Dein Name",
    "kontakt.016": "dein@beispiel.de",
    "kontakt.017": "Wie können wir helfen?",

    // ── admin ───────────────────────────────────────────────────
    "admin.001": "Secure-Darts Admin Panel",
    "admin.002": "Achtung!",
    "admin.003": "UNWIDERRUFLICH LÖSCHEN",
    "admin.004": "ABBRECHEN",
    "admin.005": "ADMIN LOGIN",
    "admin.006": "EINLOGGEN",
    "admin.007": "ZURÜCK ZUR APP",
    "admin.008": "ADMIN PANEL",
    "admin.009": "NACHRICHTEN",
    "admin.010": "DATEN BEARBEITEN",
    "admin.011": "ABBRECHEN",
    "admin.012": "SPEICHERN",
    "admin.013": "Passwort",

    // ── impressum ───────────────────────────────────────────────
    "impressum.001": "Impressum - Secure-Darts",
    "impressum.002": "Impressum",
    "impressum.003": "Angaben gemäß § 5 DDG",
    "impressum.004": "Patrick Bogdoll<br /> Reimanstraße 17<br /> 52070 Aachen<br /> Deutschland",
    "impressum.005": "Kontakt",
    "impressum.006": "Telefon: +49 (0)15679 787304<br /> E-Mail: info@secure-darts.com",
    "impressum.007": "Verantwortlich für den Inhalt",
    "impressum.008": "Patrick Bogdoll, Anschrift wie oben.",
    "impressum.009": "Verbraucherstreitbeilegung",
    "impressum.010": "Ich bin nicht bereit und nicht verpflichtet, an Streitbeilegungs­verfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.",
    "impressum.011": "Haftung für Inhalte und Links",
    "impressum.012": "Die Inhalte dieser Seiten wurden mit Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität kann keine Gewähr übernommen werden. Diese Seite enthält Links zu externen Websites Dritter, auf deren Inhalte kein Einfluss besteht. Für diese fremden Inhalte ist stets der jeweilige Anbieter verantwortlich. Werden Rechtsverletzungen bekannt, werden entsprechende Links umgehend entfernt.",
    "impressum.013": "Urheberrecht",
    "impressum.014": "Die durch den Betreiber erstellten Inhalte, der Quellcode und das Design dieser Anwendung unterliegen dem deutschen Urheberrecht. Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung des Betreibers. Das systematische Auslesen oder Kopieren von Inhalten, Datenbankstrukturen oder Administrationsbereichen ist nicht gestattet. Ebenso wenig darf die hier genannte E-Mail-Adresse für unverlangte Werbung genutzt oder der Anschein einer offiziellen Verbindung zum Betreiber erweckt werden.",
    "impressum.015": "Stand: Juli 2026",

    // ── datenschutz ─────────────────────────────────────────────
    "datenschutz.001": "Datenschutzerklärung - Secure-Darts",
    "datenschutz.002": "Datenschutzerklärung",
    "datenschutz.003": "1. Überblick",
    "datenschutz.004": "Diese Erklärung beschreibt, welche personenbezogenen Daten bei der Nutzung von Secure-Darts verarbeitet werden, zu welchem Zweck und auf welcher Rechtsgrundlage. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.",
    "datenschutz.005": "Secure-Darts ist ein privat betriebenes Projekt in aktiver Entwicklung. Die eingesetzten Dienste sind unten einzeln aufgeführt.",
    "datenschutz.006": "2. Verantwortliche Stelle",
    "datenschutz.007": "Patrick Bogdoll<br /> Reimanstraße 17<br /> 52070 Aachen<br /> Deutschland<br /> E-Mail: info@secure-darts.com",
    "datenschutz.008": "Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung personenbezogener Daten entscheidet.",
    "datenschutz.009": "3. Ihre Rechte",
    "datenschutz.010": "Sie haben jederzeit das Recht auf",
    "datenschutz.011": "<strong>Auskunft</strong> über die zu Ihnen gespeicherten Daten, deren Herkunft, Empfänger und den Zweck der Verarbeitung (Art. 15 DSGVO),",
    "datenschutz.012": "Auskunft",
    "datenschutz.013": "<strong>Berichtigung</strong> unrichtiger Daten (Art. 16 DSGVO),",
    "datenschutz.014": "Berichtigung",
    "datenschutz.015": "<strong>Löschung</strong> Ihrer Daten (Art. 17 DSGVO),",
    "datenschutz.016": "Löschung",
    "datenschutz.017": "<strong>Einschränkung der Verarbeitung</strong> (Art. 18 DSGVO),",
    "datenschutz.018": "Einschränkung der Verarbeitung",
    "datenschutz.019": "<strong>Datenübertragbarkeit</strong> – Herausgabe Ihrer Daten in einem gängigen, maschinenlesbaren Format (Art. 20 DSGVO),",
    "datenschutz.020": "Datenübertragbarkeit",
    "datenschutz.021": "<strong>Widerruf erteilter Einwilligungen</strong> mit Wirkung für die Zukunft. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Verarbeitung bleibt unberührt (Art. 7 Abs. 3 DSGVO).",
    "datenschutz.022": "Widerruf erteilter Einwilligungen",
    "datenschutz.023": "Für alle diese Anliegen genügt eine formlose E-Mail an info@secure-darts.com. Ihr Konto samt Statistiken können Sie außerdem in den Einstellungen selbst löschen.",
    "datenschutz.024": "Widerspruchsrecht (Art. 21 DSGVO)",
    "datenschutz.025": "Soweit Daten auf Grundlage berechtigter Interessen nach Art. 6 Abs. 1 lit. f DSGVO verarbeitet werden, haben Sie das Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit Widerspruch gegen diese Verarbeitung einzulegen. Die jeweilige Rechtsgrundlage ist bei jedem Dienst unten genannt. Nach einem Widerspruch werden die Daten nicht mehr verarbeitet, es sei denn, es bestehen zwingende schutzwürdige Gründe, die Ihre Interessen überwiegen, oder die Verarbeitung dient der Geltendmachung oder Verteidigung von Rechtsansprüchen.",
    "datenschutz.026": "Beschwerderecht bei der Aufsichtsbehörde (Art. 77 DSGVO)",
    "datenschutz.027": "Unabhängig davon steht Ihnen ein Beschwerderecht bei einer Datenschutz-Aufsichtsbehörde zu, insbesondere in dem Mitgliedstaat Ihres Aufenthaltsorts, Ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes. Zuständig für den Betreiber ist:",
    "datenschutz.028": "Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen<br /> Kavalleriestraße 2–4, 40213 Düsseldorf<br /> <a href=\"https://www.ldi.nrw.de\">www.ldi.nrw.de</a>",
    "datenschutz.029": "www.ldi.nrw.de",
    "datenschutz.030": "4. Speicherdauer",
    "datenschutz.031": "Sofern unten keine andere Dauer genannt ist, gilt: Kontodaten und Spielstatistiken werden gespeichert, solange Ihr Konto besteht, und nach dessen Löschung entfernt. Server-Logfiles des Hosting-Anbieters werden nach dessen Vorgaben nach kurzer Zeit gelöscht oder anonymisiert. Nachrichten über das Kontaktformular werden gelöscht, sobald das Anliegen erledigt ist und keine gesetzlichen Aufbewahrungspflichten entgegenstehen.",
    "datenschutz.032": "5. Datensicherheit",
    "datenschutz.033": "Die Verbindung zu dieser Website ist durchgehend mit TLS verschlüsselt (erkennbar an <em>https://</em> in der Adresszeile). Passwörter werden niemals im Klartext gespeichert, sondern ausschließlich als kryptografischer Hash beim Authentifizierungsdienst hinterlegt – auch der Betreiber kann sie nicht einsehen.",
    "datenschutz.034": "https://",
    "datenschutz.035": "Ihre Daten werden ausschließlich zu den hier genannten Zwecken verwendet. Sie werden nicht verkauft, nicht vermietet und nicht für unaufgeforderte Werbung genutzt.",
    "datenschutz.036": "6. Aufruf der Website (Hosting)",
    "datenschutz.037": "Diese Website wird bei GitHub Pages gehostet. Anbieter ist die GitHub, Inc., 88 Colin P Kelly Jr St, San Francisco, CA 94107, USA.",
    "datenschutz.038": "Beim Aufruf erfasst GitHub technisch bedingt Verbindungsdaten in Server-Logfiles: IP-Adresse, Browsertyp und -version, Betriebssystem, Referrer-URL, Hostname und Uhrzeit der Anfrage. Das ist notwendig, um die Seite an Ihren Browser auszuliefern und den Betrieb sicher und stabil zu halten. Eine Zusammenführung dieser Daten mit anderen Quellen findet nicht statt.",
    "datenschutz.039": "Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO – berechtigtes Interesse an einer zuverlässigen und sicheren Bereitstellung des Angebots. Die Übermittlung in die USA wird auf das EU-US Data Privacy Framework und ergänzend auf Standardvertragsklauseln der EU-Kommission gestützt.",
    "datenschutz.040": "7. Konto, Anmeldung und Spieldaten (Supabase)",
    "datenschutz.041": "Für Registrierung, Anmeldung und die Speicherung von Spielständen nutzen wir Supabase. Anbieter ist die Supabase, Inc., 970 16th Street, San Francisco, CA 94107, USA. Die Datenhaltung ist auf ein europäisches Rechenzentrum konfiguriert.",
    "datenschutz.042": "Verarbeitet werden:",
    "datenschutz.043": "E-Mail-Adresse und Passwort (nur als Hash),",
    "datenschutz.044": "gewählter Benutzername und Profilbild,",
    "datenschutz.045": "Spielstatistiken, Matchverläufe, Freundesliste und Lobby-Zugehörigkeit.",
    "datenschutz.046": "Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO – die Verarbeitung ist zur Bereitstellung des Spielkontos erforderlich. Mit Supabase besteht ein Vertrag zur Auftragsverarbeitung nach Art. 28 DSGVO.",
    "datenschutz.047": "Für andere Spieler sichtbare Daten",
    "datenschutz.048": "Secure-Darts ist ein Mehrspielerdienst. Ihr Benutzername, Ihr Profilbild und Ihre Spielergebnisse sind für Mitspieler in gemeinsamen Partien, in Lobbys und – sofern Sie eine Freundschaft bestätigen – in deren Freundesliste sichtbar. Wählen Sie einen Benutzernamen, unter dem Sie erkannt werden möchten. Ein Klarname ist nicht erforderlich.",
    "datenschutz.049": "8. Anmeldung mit Google (Single Sign-On)",
    "datenschutz.050": "Sie können sich wahlweise mit Ihrem Google-Konto anmelden. Anbieter ist die Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland. Dabei werden Sie zu Google weitergeleitet; nach erfolgreicher Anmeldung erhalten wir Ihre E-Mail-Adresse und Ihren dort hinterlegten Namen, um Ihr Konto einzurichten und Sie wiederzuerkennen.",
    "datenschutz.051": "Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO. Die Nutzung ist freiwillig – eine Registrierung mit E-Mail-Adresse und Passwort ist ebenso möglich.",
    "datenschutz.052": "9. Kontaktformular",
    "datenschutz.053": "Über das Kontaktformular übermittelte Angaben – Name, E-Mail-Adresse, Kategorie und Nachrichtentext – werden in der Datenbank bei Supabase gespeichert, damit das Anliegen bearbeitet werden kann. Sind Sie angemeldet, wird die Nachricht Ihrem Konto zugeordnet.",
    "datenschutz.054": "Nachrichten in dringenden Kategorien sowie Nachrichten von nicht angemeldeten Gästen werden zusätzlich per E-Mail weitergeleitet. Diesen Versand übernimmt Formspree, Inc., USA. Übermittelt werden dabei Name, E-Mail-Adresse, Kategorie und Nachrichtentext.",
    "datenschutz.055": "Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO, soweit die Anfrage einen Vertrag betrifft, im Übrigen Art. 6 Abs. 1 lit. f DSGVO – berechtigtes Interesse an der Bearbeitung von Anfragen und Fehlermeldungen.",
    "datenschutz.056": "10. Profilbilder (DiceBear)",
    "datenschutz.057": "Wenn Sie kein eigenes Profilbild hinterlegt haben, wird ein automatisch erzeugter Avatar über die Schnittstelle <em>api.dicebear.com</em> geladen. Ihr Browser stellt dazu eine Verbindung zu diesem Dienst her; dabei wird Ihre IP-Adresse übermittelt. Übergeben wird außerdem Ihr Benutzername als Erzeugungsmerkmal.",
    "datenschutz.058": "api.dicebear.com",
    "datenschutz.059": "Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO – berechtigtes Interesse an einer einheitlichen Darstellung ohne eigene Bildverwaltung.",
    // 060-064 (LiveKit) am 20.08.2026 entfernt: Die Funktion wurde am
    // 08.08.2026 ausgebaut (camera.js) - der Abschnitt beschrieb einen
    // Dienst, den es nicht mehr gibt (Befund D1, PLAN_BIS_PROTOTYP).
    // Nachfolger: 079-087 (Tracker lokal + Download).
    "datenschutz.065": "13. Speicherung auf Ihrem Endgerät",
    "datenschutz.066": "Wir setzen keine Cookies zu Analyse- oder Werbezwecken ein. Genutzt wird ausschließlich der lokale Speicher Ihres Browsers, und zwar für Ihre Anmeldesitzung, für Angaben wie den aktuellen Raumcode (damit ein laufendes Spiel nach einem Neuladen fortgesetzt werden kann), für Anzeigeeinstellungen wie Schriftgröße und Sprache, für die zufällige Gerätekennung aus Abschnitt 7 (Fehlerberichte) sowie – bei Nutzung des Trackers ohne Anmeldung – für eine Warteschlange von bis zu 500 erkannten Würfen (Feld und Trefferposition, keine Bilder), die erst nach einer Anmeldung in Ihre Statistiken übernommen wird.",
    "datenschutz.067": "Diese Speicherung ist für den von Ihnen ausdrücklich gewünschten Dienst unbedingt erforderlich und daher nach § 25 Abs. 2 Nr. 2 TDDDG einwilligungsfrei. Sie können den lokalen Speicher jederzeit über die Einstellungen Ihres Browsers leeren; laufende Spielsitzungen gehen dabei verloren.",
    "datenschutz.068": "14. Verweise auf externe Dienste",
    "datenschutz.069": "Diese Seite verlinkt auf Discord, Instagram und TikTok. Ein Aufruf dieser Links verlässt Secure-Darts; ab diesem Zeitpunkt gelten die Datenschutzbestimmungen der jeweiligen Anbieter. Vor dem Klick werden keine Daten an diese Dienste übermittelt.",
    "datenschutz.070": "15. Änderungen dieser Erklärung",
    "datenschutz.071": "Diese Erklärung wird angepasst, sobald Änderungen an der Anwendung oder an den eingesetzten Diensten dies erfordern. Es gilt die jeweils hier abrufbare Fassung.",
    "datenschutz.072": "Stand: August 2026",
    "datenschutz.073": "Wurfdaten aus der Kameraerkennung (Heatmap)",
    "datenschutz.074": "Nutzen Sie den lokalen Tracker (Abschnitt 11), speichert die App zu jedem erkannten Wurf das getroffene Feld und die Trefferposition auf der Scheibe in Millimetern, zusammen mit dem Spielmodus und – im Modus Secure – dem Zielfeld. Diese Wurfdaten werden Ihrem Konto zugeordnet und für Ihre eigenen Statistiken verwendet, etwa die Treffer-Heatmap. Kamerabilder gehören nicht dazu. Ohne Anmeldung werden keine Wurfdaten an uns übertragen; sie warten bis zu einer Anmeldung ausschließlich im lokalen Speicher Ihres Browsers (Abschnitt 13).",
    "datenschutz.075": "Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO – die Verarbeitung ist zur Bereitstellung der Statistikfunktionen Ihres Kontos erforderlich. Die Wurfdaten werden mit der Löschung Ihres Kontos entfernt.",
    "datenschutz.076": "Fehlerberichte (Telemetrie)",
    "datenschutz.077": "Tritt in der App ein technischer Fehler auf, wird eine Fehlermeldung in der Datenbank bei Supabase gespeichert: Fehlertext, betroffene Stelle im Programm, Browsertyp und der gerade geöffnete Bildschirm. Bei angemeldeten Nutzern wird die Meldung dem Konto zugeordnet; bei Gästen stattdessen einer zufällig erzeugten Gerätekennung (eine Zufalls-UUID im lokalen Speicher Ihres Browsers, kein Fingerabdruck), damit erkennbar bleibt, ob mehrere Meldungen vom selben Gerät stammen. Die Zahl der Meldungen ist je Sitzung auf wenige Einträge begrenzt; Spielinhalte oder Kamerabilder sind nicht enthalten.",
    "datenschutz.078": "Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO – berechtigtes Interesse an einem stabilen und fehlerfreien Betrieb der Anwendung.",
    "datenschutz.079": "11. Kameraerkennung: der Secure-Darts Tracker (lokale Software)",
    "datenschutz.080": "Der Tracker ist ein Programm, das Sie auf Ihrem eigenen Rechner installieren. Es wertet die Bilder der an Ihrer Dartscheibe montierten Kameras aus, um Würfe automatisch zu erkennen. Die gesamte Bildverarbeitung findet ausschließlich lokal auf Ihrem Rechner statt – die Kamerabilder werden weder an uns noch an Dritte übertragen. Im Einzelnen:",
    "datenschutz.081": "Die Wurfbilder (kleine Bildausschnitte um die Pfeilspitze, in der App zu jedem erkannten Dart angezeigt) entstehen im Arbeitsspeicher, werden über eine lokale Verbindung innerhalb Ihres Rechners (127.0.0.1) an Ihren eigenen Browser übergeben und spätestens mit der nächsten Aufnahme überschrieben. Sie werden nicht gespeichert und verlassen Ihr Gerät nicht.",
    "datenschutz.082": "Der optionale Mitschnitt (ein Schalter im Statusfenster des Trackers, standardmäßig aus) speichert Kamerabilder erkannter Würfe ausschließlich in einem Ordner auf Ihrem eigenen Rechner. Ob Sie diese Dateien behalten, löschen oder weitergeben, entscheiden allein Sie.",
    "datenschutz.083": "Das Wertungsprotokoll des Trackers (erkannte Felder und Ihre Handkorrekturen, ohne Bilder) wird als Datei auf Ihrem eigenen Rechner geführt.",
    "datenschutz.084": "An die Web-App übergibt der Tracker die erkannten Würfe (Feld, Punktzahl, Trefferposition) über die genannte lokale Verbindung; für die anschließende Speicherung in Ihrem Konto gilt Abschnitt 7, für den lokalen Browser-Speicher Abschnitt 13. Diese Verarbeitung läuft vollständig auf Ihrem Gerät und unter Ihrer Kontrolle; dieser Abschnitt dient der Transparenz. Ob eine neuere Tracker-Fassung vorliegt, prüft die Web-App gegen eine mit der Website ausgelieferte Versionsdatei (Abschnitt 6) – dabei werden keine zusätzlichen Daten übertragen.",
    "datenschutz.085": "12. Download des Trackers (Cloudflare R2)",
    "datenschutz.086": "Die Installationsdatei des Trackers liegt bei der Cloudflare, Inc., 101 Townsend St, San Francisco, CA 94107, USA (Speicherdienst R2). Der Download steht derzeit nur Teilnehmern des geschlossenen Tests zur Verfügung: Eine Serverfunktion bei Supabase prüft Ihre Anmeldung und Ihre Testberechtigung und stellt eine kurzlebige, signierte Downloadadresse aus. Beim Herunterladen wird Ihre IP-Adresse technisch bedingt an Cloudflare übermittelt.",
    "datenschutz.087": "Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO – die Bereitstellung der von Ihnen angeforderten Software. Die Übermittlung in die USA wird auf das EU-US Data Privacy Framework und ergänzend auf Standardvertragsklauseln der EU-Kommission gestützt.",

    // ── 121game ─────────────────────────────────────────────────
    "121game.001": "Darts geworfen",
    "121game.002": "Höchstes Ziel",
    "121game.003": "Letzten Wurf rückgängig",
    "121game.004": "Spiel abbrechen",
    "121game.005": "Verlauf",
    "121game.006": "Punkte eingeben...",

    // ── 121 ─────────────────────────────────────────────────────
    "121.001": "Catch <span style=\"color: var(--accent)\">121</span>",
    "121.002": "Checke das Ziel in 9 Darts. Schaffst du es, geht's eine Zahl hoch!",
    "121.003": "Ziel",
    "121.004": "Start-Ziel",
    "121.005": "Safe-Points",
    "121.006": "alle 5 Zahlen (z.B. 125, 130)",
    "121.007": "Spieler",
    "121.008": "Name",
    "121.009": "Spieler",
    "121.010": "Zurück",
    "121.011": "Spiel Starten",
    "121.012": "Dein Name...",

    // ── 501game ─────────────────────────────────────────────────
    "501game.001": "Game Shot!",
    "501game.002": "Nächstes Leg starten",
    "501game.003": "Neues Spiel (Rematch)",
    "501game.004": "Zum Hauptmenü",
    "501game.005": "Rest",
    "501game.006": "Letzte Aufnahmen",
    "501game.008": "Kein Tracker verbunden",
    "501game.009": "Tracker starten, dann erscheinen die Wrfe hier.",
    "501game.010": "Gesamt",
    "501game.011": "Miss",
    // Vokabular (29.08.2026): EIN Wort je Aktion - siehe Produkttest,
    // Tabelle "Inkonsistenzen". Bestaetigen statt Next/OK/Zug beenden;
    // Multiplikatoren einheitlich ausgeschrieben.
    "501game.012": "Bestätigen",
    "501game.013": "Single",
    "501game.014": "Double",
    "501game.015": "Triple",
    "501game.016": "MISS",
    "501game.017": "Letzten Wurf rückgängig",
    "501game.018": "Spiel abbrechen",
    "501game.019": "Rest",
    "501game.020": "Letzte Aufnahmen",

    // ── 501 ─────────────────────────────────────────────────────
    "501.001": "<span style=\"color: var(--accent)\">501</span> Darts",
    "501.002": "Der absolute Klassiker",
    "501.003": "Match",
    "501.004": "Start-Score",
    "501.005": "Länge",
    "501.006": "Best of 1",
    "501.007": "Best of 3",
    "501.008": "Best of 5",
    "501.009": "Best of 7",
    "501.010": "Best of 9",
    "501.011": "Modus",
    "501.012": "Lokal",
    "501.013": "Online",
    "501.014": "Lokales Spiel",
    "501.015": "Spieler 1",
    "501.016": "Spieler 2",
    "501.017": "Statistiken",
    "501.018": "Gast-Login",
    "501.019": "Lokal Starten",
    "501.020": "Online-Lobby",
    "501.021": "Online-Name",
    "501.022": "Sichtbarkeit",
    "501.023": "Öffentlich",
    "501.024": "Kamera-Pflicht",
    "501.025": "Raum",
    "501.026": "Beitreten",
    "501.027": "Hosten",
    "501.028": "Zurück",
    "501.029": "Online Lobby",
    "501.030": "Raumcode:",
    "501.031": "Host",
    "501.032": "Gast",
    "501.033": "Wartet...",
    "501.034": "Lobby verlassen",
    "501.035": "Dein Name",
    "501.036": "Spieler 2 / Bot",
    "501.037": "Bot einsetzen",
    "501.038": "Dein Online-Name...",
    "501.039": "CODE",

    // ── bobsgame ────────────────────────────────────────────────
    "bobsgame.001": "Spieler",
    "bobsgame.002": "Score",
    "bobsgame.003": "Aktuelles Ziel",
    "bobsgame.004": "Wie oft hast du das Doppel getroffen?",
    "bobsgame.005": "Letzten Wurf rückgängig",
    "bobsgame.006": "Spiel abbrechen",

    // ── bobs ────────────────────────────────────────────────────
    "bobs.001": "Das ultimative Doppel-Training",
    "bobs.002": "Regeln",
    "bobs.003": "Easy Mode",
    "bobs.004": "Kein Game Over unter 0",
    "bobs.005": "Startpunktzahl 27. Triff das vorgegebene Doppel. Verfehlst du, wird der Wert abgezogen. Fällst du unter 0, bist du raus.",
    "bobs.006": "Spieler",
    "bobs.007": "Name",
    "bobs.008": "Spieler",
    "bobs.009": "Zurück",
    "bobs.010": "Spiel Starten",
    "bobs.011": "Dein Name...",

    // ── cricketgame ─────────────────────────────────────────────
    "cricketgame.001": "Spiel abbrechen",
    "cricketgame.002": "Spieler 1",
    "cricketgame.003": "Spieler 2",
    "cricketgame.004": "Spieler 1 wirft... (0/3)",
    "cricketgame.005": "Single",
    "cricketgame.006": "Double",
    "cricketgame.007": "Triple",
    "cricketgame.008": "Fehlwurf",
    "cricketgame.009": "Bestätigen",
    "cricketgame.010": "Undo",
    "cricketgame.011": "Tastatur: 1/2/3 = Multiplikator · 0 = Fehlwurf · Enter = Bestätigen · Backspace = Undo",

    // ── cricket ─────────────────────────────────────────────────
    "cricket.001": "Tactics",
    "cricket.002": "Jedes Feld 3x treffen. Danach gibt es Punkte, solange der Gegner offen hat.",
    "cricket.003": "Variante",
    "cricket.004": "Modus",
    "cricket.005": "Cricket 15 – Bull",
    "cricket.006": "Tactics 10 – Bull",
    "cricket.007": "Solo-Training",
    "cricket.008": "nur Felder schließen, Darts zählen",
    "cricket.009": "Spieler",
    "cricket.010": "Spieler 1",
    "cricket.011": "Spieler 2",
    "cricket.012": "Zurück",
    "cricket.013": "Spiel Starten",
    "cricket.014": "Spieler 1",
    "cricket.015": "Spieler 2",

    // ── gotchagame ──────────────────────────────────────────────
    "gotchagame.001": "Letzte Aufnahme rückgängig",
    "gotchagame.002": "Spiel abbrechen",

    // ── gotcha ──────────────────────────────────────────────────
    "gotcha.001": "GOT<span style=\"color: var(--accent)\">CHA</span>",
    "gotcha.002": "Hochzählen, exakt treffen – und Gleichstand wirft den Gegner auf 0",
    "gotcha.003": "Spiel",
    "gotcha.004": "Zielzahl",
    "gotcha.005": "Regeln",
    "gotcha.006": "Alle starten bei 0 und zählen hoch. Landest du exakt auf dem Stand eines Mitspielers, fällt er zurück auf 0 („Gotcha!\"). Sieg nur mit exakter Zielzahl – Überwerfen ist Bust.",
    "gotcha.007": "Spieler (2–8)",
    "gotcha.008": "Hinzufügen",
    "gotcha.009": "Zurück",
    "gotcha.010": "Spiel Starten",
    "gotcha.011": "Spielername...",

    // ── partygame ───────────────────────────────────────────────
    "partygame.001": "SINGLE",
    "partygame.002": "DOUBLE",
    "partygame.003": "TRIPLE",
    "partygame.004": "MISS",
    "partygame.005": "Letzten Wurf rückgängig",
    "partygame.006": "Spiel abbrechen",

    // ── party ───────────────────────────────────────────────────
    "party.001": "2 bis 8 Spieler Couch-Koop",
    "party.002": "Spiel",
    "party.003": "Start-Punktzahl",
    "party.004": "Spieler",
    "party.005": "Hinzufügen",
    "party.006": "Zurück",
    "party.007": "Spiel Starten",
    "party.008": "Spielername...",

    // ── randomgame ──────────────────────────────────────────────
    "randomgame.001": "Spieler",
    "randomgame.002": "Beenden",
    "randomgame.003": "Runde 1 / 10",
    "randomgame.004": "Getroffen",
    "randomgame.005": "Quote",
    "randomgame.006": "Mit wie vielen Darts gecheckt?",
    "randomgame.007": "Andere Zahl",
    "randomgame.008": "Undo",
    "randomgame.009": "Tastatur: 1..N = mit N Darts gecheckt · 0 = verfehlt · Backspace = Undo",

    // ── random ──────────────────────────────────────────────────
    "random.001": "<span style=\"color: var(--accent)\">Random</span> Checkout",
    "random.002": "Random",
    "random.003": "Eine Zufallszahl, X Darts Zeit. Wie oft schaffst du es?",
    "random.004": "Zahlen",
    "random.005": "Voreinstellung",
    "random.006": "Leicht",
    "random.007": "Mittel",
    "random.008": "Schwer",
    "random.009": "Bereich",
    "random.010": "bis",
    "random.011": "Wiederholung",
    "random.012": "Zahlen dürfen sich wiederholen",
    "random.013": "Durchgang",
    "random.014": "Darts",
    "random.015": "Runden",
    "random.016": "Spieler",
    "random.017": "Spieler",
    "random.018": "Zurück",
    "random.019": "Spiel Starten",
    "random.020": "Dein Name...",

    // ── rtwgame ─────────────────────────────────────────────────
    "rtwgame.001": "Spieler",
    "rtwgame.002": "Gesamtpunkte:",
    "rtwgame.003": "Aktuelles Ziel",
    "rtwgame.004": "Wie oft hast du das Ziel getroffen?",
    "rtwgame.005": "Letzten Wurf rückgängig",
    "rtwgame.006": "Spiel abbrechen",

    // ── rtw ─────────────────────────────────────────────────────
    "rtw.001": "Round the <span style=\"color: var(--accent)\">World</span>",
    "rtw.002": "World",
    "rtw.003": "Einmal um das ganze Board",
    "rtw.004": "Spielmodus",
    "rtw.005": "Ziel-Modus",
    "rtw.006": "Single",
    "rtw.007": "Double",
    "rtw.008": "Triple",
    "rtw.009": "Beliebig",
    "rtw.010": "Spieler",
    "rtw.011": "Name",
    "rtw.012": "Spieler",
    "rtw.013": "Zurück",
    "rtw.014": "Spiel Starten",
    "rtw.015": "Dein Name...",

    // ── scoring ─────────────────────────────────────────────────
    "scoring.001": "Scoring <span style=\"color: var(--accent)\">Training</span>",
    "scoring.002": "Training",
    "scoring.003": "Open End – einfach werfen, der Average läuft mit",
    "scoring.004": "3-Dart-Average",
    "scoring.005": "Darts",
    "scoring.006": "Punkte",
    "scoring.007": "Beste Aufnahme",
    "scoring.008": "180er",
    "scoring.009": "Letzte Aufnahmen",
    "scoring.010": "Letzte Aufnahme rückgängig",
    "scoring.011": "Sitzung zurücksetzen",
    "scoring.012": "Training beenden",
    "scoring.013": "Aufnahme eingeben...",

    // ── securegame ──────────────────────────────────────────────
    "securegame.001": "STOP / KORREKTUR",
    "securegame.002": "Spieler 1",
    "securegame.004": "Ziel",
    "securegame.005": "1 · Sammeln",
    "securegame.006": "2 · Sichern",
    "securegame.007": "Offen",
    "securegame.008": "0 × ungesichert",
    "securegame.009": "Reset",
    "securegame.010": "✓ Bestätigen",
    "securegame.011": "↶ Letzten Wurf rückgängig",
    "securegame.012": "Spiel abbrechen",
    "securegame.013": "Spiel beendet.",
    "securegame.014": "🔁 Revanche",
    "securegame.015": "Darts in Phase 1",
    "securegame.016": "Darts in Phase 2",

    // ── securelobby ─────────────────────────────────────────────
    "securelobby.001": "Online",
    "securelobby.002": "Raumcode",
    "securelobby.003": "Code kopieren",
    "securelobby.004": "Host",
    "securelobby.005": "Host",
    "securelobby.006": "Gegner",
    "securelobby.007": "Wartet...",
    "securelobby.008": "Spiel Starten",
    "securelobby.009": "Lobby verlassen",

    // ── securerules ─────────────────────────────────────────────
    "securerules.001": "Spielregeln",
    "securerules.002": "Ziel ist es, die meisten Punkte zu sammeln, während man die Zahlen von <b>1 bis 20</b>, dann <b>25</b> (Single Bull) und <b>50</b> (Bullseye) durchläuft.",
    "securerules.003": "1 bis 20",
    "securerules.004": "<b>Kurzmodus (10-Bull):</b> Gleiche Regeln, aber die Leiter beginnt erst bei der <b>10</b> – ideal für schnelle Runden. Auswählbar im Setup unter „Variante\".",
    "securerules.005": "Kurzmodus (10-Bull):",
    "securerules.006": "1. Punkte Sammeln",
    "securerules.007": "In der ersten Phase (3 Darts) wirft man auf die aktuelle Zielzahl. Man sammelt so viele Punkte wie möglich.",
    "securerules.008": "Single = Einfache Punktzahl",
    "securerules.009": "Double = Doppelte Punktzahl",
    "securerules.010": "Triple = Dreifache Punktzahl",
    "securerules.011": "2. Das Sichern",
    "securerules.012": "In der zweiten Phase (3 Darts) muss man die Punkte über das Bullseye \"sichern\".",
    "securerules.013": "<b>Single Bull (25):</b> Die Punkte sind gesichert (x1).",
    "securerules.014": "Single Bull (25):",
    "securerules.015": "<b>Bullseye (50):</b> Die Punkte werden gesichert und <b>verdoppelt</b> (x2).",
    "securerules.016": "Bullseye (50):",
    "securerules.017": "verdoppelt",
    "securerules.018": "<b>Nichts getroffen:</b> 0 Punkte für diese Runde.",
    "securerules.019": "Nichts getroffen:",
    "securerules.020": "Beispiel: Du triffst 3x die 20 (60 Punkte).<br /> Dann triffst du 1x Bullseye.<br /> Ergebnis: 60 x 2 = <b>120 Punkte</b>.",
    "securerules.021": "120 Punkte",
    "securerules.022": "3. Globaler Fortschritt",
    "securerules.023": "Alle Spieler werfen auf die gleiche Zahl. Die Zahl erhöht sich erst für alle, wenn <b>mindestens ein Spieler</b> in der Runde erfolgreich gesichert hat.",
    "securerules.024": "mindestens ein Spieler",
    "securerules.025": "4. Trainings-Modus",
    "securerules.026": "Setze den Haken im Setup. Deine Statistiken werden separat gespeichert und zählen nicht zu deinen offiziellen Siegen.",
    "securerules.027": "5. Bot-Gegner",
    "securerules.028": "Wähle im Setup einen Bot aus. Bots werden <b>nicht</b> in der Statistik gespeichert.",
    "securerules.029": "nicht",
    "securerules.030": "Zurück zum Setup",

    // ── securesetup ─────────────────────────────────────────────
    "securesetup.001": "Darts",
    "securesetup.002": "Taktisches Punkte-Sichern",
    "securesetup.003": "Match",
    "securesetup.004": "Modus",
    "securesetup.005": "Lokal",
    "securesetup.006": "Online",
    "securesetup.007": "Lokales Spiel",
    "securesetup.008": "Spieler",
    "securesetup.009": "Weitere",
    "securesetup.010": "+ Bot",
    "securesetup.011": "Gast-Login",
    "securesetup.012": "Teilnehmer",
    "securesetup.013": "Variante",
    "securesetup.014": "Kurzmodus (10 bis Bull)",
    "securesetup.017": "Start",
    "securesetup.018": "Lokal Starten",
    "securesetup.019": "Online-Lobby",
    "securesetup.020": "Online-Name",
    "securesetup.021": "Sichtbarkeit",
    "securesetup.022": "Öffentlich",
    "securesetup.023": "Kamera-Pflicht",
    "securesetup.024": "Variante",
    "securesetup.025": "Kurzmodus (10 bis Bull, Host entscheidet)",
    "securesetup.026": "Raum",
    "securesetup.027": "Beitreten",
    "securesetup.028": "Hosten",
    "securesetup.029": "Offene Lobbys",
    "securesetup.030": "Aktualisieren",
    "securesetup.031": "Zurück",
    "securesetup.032": "Spielregeln",
    "securesetup.033": "Spielername tippen...",
    "securesetup.034": "Spieler hinzufügen",
    "securesetup.035": "Dein Online-Name...",
    "securesetup.036": "CODE",

    // ── app ─────────────────────────────────────────────────────
    "app.123": "Name",
    "app.124": "Lade Verlauf...",
    "app.125": "Eingabe",
    "app.126": "Möchtest du das wirklich tun?",
    "app.127": "Ich",
    "app.128": "Gegner",
    "app.129": "Ich",
    "app.130": "Gegner",

    // ── admin ───────────────────────────────────────────────────
    "admin.014": "Möchtest du das wirklich tun?",

    // ── einstellungen ───────────────────────────────────────────
    "einstellungen.001": "Secure Darts – Einstellungen",
    "einstellungen.002": "Name und Profilbild änderst du im Profil.",
    "einstellungen.003": "Eine Änderung muss über die alte und die neue Adresse bestätigt werden.",
    "einstellungen.004": "Leer lassen, um es nicht zu ändern.",
    "einstellungen.005": "Beim automatischen Zählen stehst du an der Abwurflinie und liest aus ein bis zwei Metern mit. Größer stellen hilft dann.",
    "einstellungen.006": "Grün (Logo)",
    "einstellungen.007": "Blau (Logo)",
    "einstellungen.008": "Rot",
    "einstellungen.009": "Lila",
    "einstellungen.010": "Orange",
    "einstellungen.011": "Cyan",
    "einstellungen.012": "Pink",
    "einstellungen.013": "Limette",
    "einstellungen.014": "Deutsch",
    "einstellungen.015": "English",
    "einstellungen.017": "Dein Code",
    "einstellungen.018": "Gib diesen Code am Hauptgerät ein (gültig für 5 Min):",
    "einstellungen.019": "Schließen",
    "einstellungen.020": "Achtung!",
    "einstellungen.021": "Möchtest du das wirklich tun?",
    "einstellungen.022": "Ja, bestätigen",
    "einstellungen.023": "Abbrechen",

    // ── 121game ─────────────────────────────────────────────────
    "121game.007": "Spieler",

    // ── 501game ─────────────────────────────────────────────────
    "501game.021": "Spieler gewinnt!",
    "501game.022": "S1",
    "501game.023": "Best of 3 Legs",
    "501game.024": "Spieler 1",
    "501game.025": "0 Darts",
    "501game.026": "Spieler 2",
    "501game.027": "0 Darts",
    "501game.028": "Frage?",
    "501game.029": "S2",

    // ── 501 ─────────────────────────────────────────────────────
    "501.040": "Wartet...",
    "501.041": "Spiel Starten",

    // ── bobsgame ────────────────────────────────────────────────
    "bobsgame.007": "Spieler wirft...",
    "bobsgame.008": "D1",

    // ── partygame ───────────────────────────────────────────────
    "partygame.007": "Dart-für-Dart Eingabe",

    // ── rtwgame ─────────────────────────────────────────────────
    "rtwgame.007": "Spieler wirft...",

    // ── securegame ──────────────────────────────────────────────
    "securegame.017": "Bot spielt...",

    // ── app ─────────────────────────────────────────────────────
    "app.zurueckApp": "ZURÜCK ZUR APP",
    "app.zurueck": "ZURÜCK",
    "app.meineStats": "Meine Statistiken ansehen",

    // ── g121 ────────────────────────────────────────────────────
    "g121.ziel": "Ziel:",

    // ── 501game ─────────────────────────────────────────────────
    "501game.letzterWurf": "Letzter Wurf:",

    // ── recht ───────────────────────────────────────────────────
    "recht.hinweis": "Maßgeblich ist die deutsche Fassung dieser Seite.",

    // ── app ─────────────────────────────────────────────────────
    "app.googleLogin": "Mit Google anmelden",
    "app.anfragen": "Anfragen",
    "app.vergleichen": "Vergleichen",
    "app.vergleich": "Vergleich:",
    "app.gesamt": "Gesamt:",
    "app.historie": "Historie",

    // ── 501game ─────────────────────────────────────────────────
    "501game.aufnahme": "Aufnahme",

    // ── securegame ──────────────────────────────────────────────
    "securegame.rohpunkte": "Rohpunkte:",
    "securegame.spielstand": "Aktueller Spielstand",
    "securegame.pkt": "Pkt",

    // ── app ─────────────────────────────────────────────────────
    "app.herausfordernVor": "Wie möchtest du gegen",
    "app.herausfordernNach": " spielen?",

    // ── js.app ──────────────────────────────────────────────────
    "js.app.001": "Spieler 1",
    "js.app.002": "Spieler 2",
    "js.app.003": "Geschlossener Alpha-Test – Zugang über das Kontaktformular",
    "js.app.004": "keine URL",
    "js.app.005": "Download gerade nicht möglich – bitte neu anmelden oder später erneut versuchen.",

    // ── js.auth ─────────────────────────────────────────────────
    "js.auth.001": "Bitte E-Mail und Passwort eingeben.",
    "js.auth.002": "Wir haben Dir eine Bestätigungs-Mail geschickt!",
    "js.auth.003": "Als Gast kannst du keinen Namen speichern.",
    "js.auth.004": "Darts-Name ändern",
    "js.auth.005": "So erscheinst du in Statistiken und Online-Spielen.",
    "js.auth.006": "Dieser Name ist für Administratoren reserviert.",
    "js.auth.007": "Fehler beim Speichern: ",
    "js.auth.008": "Name geändert auf: ",
    "js.auth.009": "Bitte gib deine E-Mail oben ein, um das Passwort zurückzusetzen.",
    "js.auth.010": "Fehler: ",
    "js.auth.011": "E-Mail zum Zurücksetzen wurde gesendet!",
    "js.auth.012": "Passwort zu kurz oder abgebrochen. Bitte fordere den Link erneut an.",
    "js.auth.013": "Passwort konnte nicht gespeichert werden: ",
    "js.auth.014": "Möchtest du deinen Account wirklich dauerhaft löschen? Dies kann nicht rückgängig gemacht werden!",
    "js.auth.015": "Lösche Account...",
    "js.auth.016": "Dein Account wurde erfolgreich gelöscht.",
    "js.auth.017": "Fehler beim Löschen: ",
    "js.auth.018": "Account unwiderruflich löschen",

    // ── js.autoscore ────────────────────────────────────────────
    "js.autoscore.001": "Auto-Scoring läuft in einem anderen Fenster",
    "js.autoscore.002": "BUST — Aufnahme übernommen. Pfeile ziehen.",
    "js.autoscore.003": "Tracker starten, dann erscheinen die Würfe hier.",
    "js.autoscore.004": "Würfe werden direkt gewertet. Pfeile ziehen — weiter.",
    "js.autoscore.005": "Antippen zum Korrigieren. Pfeile ziehen übernimmt die Aufnahme.",
    "js.autoscore.006": "Pfeile ziehen — dann wird übernommen.",

    // ── js.camera ───────────────────────────────────────────────
    "js.camera.001": "Deine Login-Sitzung ist ungültig. Bitte logge dich einmal aus und wieder ein!",

    // ── js.friends ──────────────────────────────────────────────
    "js.friends.001": "Ihr seid bereits befreundet oder es gibt schon eine offene Anfrage.",
    "js.friends.002": "Fehler beim Senden: ",
    "js.friends.003": "Konnte nicht angenommen werden: ",
    "js.friends.004": "Löschen fehlgeschlagen: ",
    "js.friends.005": "Lobby-Fehler: ",

    // ── js.g121 ─────────────────────────────────────────────────
    "js.g121.001": "Fehler beim Speichern der 121-Stats:",
    "js.g121.002": "Unerwarteter Fehler beim Speichern:",
    "js.g121.003": "Maximal 180 Punkte pro Aufnahme!",

    // ── js.g501 ─────────────────────────────────────────────────
    "js.g501.001": "Bitte gib deinen Namen ein!",
    "js.g501.002": "Bitte gib einen Raumcode ein!",
    "js.g501.003": "Raum nicht gefunden!",
    "js.g501.004": "Das Spiel läuft bereits.",
    "js.g501.005": "Ungültige Eingabe!",
    "js.g501.006": "Gegner wirft...",
    "js.g501.007": "Nicht am Zug — Wurf wurde nicht gewertet.",
    "js.g501.008": "Score muss zwischen 0 und 180 liegen!",
    "js.g501.009": "Datenbank-Fehler beim Senden: ",
    "js.g501.010": "Fehler!",
    "js.g501.011": "Fehler beim Verarbeiten des Wurfs:",
    "js.g501.012": "Wurf konnte nicht verarbeitet werden!",
    "js.g501.013": "Ein Spieler",
    "js.g501.014": "\n(Warte auf Host für Rematch...)",
    "js.g501.015": "Stats konnten nicht gespeichert werden.",
    "js.g501.016": "Nächstes Leg startet...",
    "js.g501.017": "Undo nicht mehr möglich — dein Gegner hat bereits geworfen.",
    "js.g501.018": "Code ungültig oder abgelaufen.",

    // ── js.bobs ─────────────────────────────────────────────────
    "js.bobs.001": "Game Over! Du bist unter 0 Punkte gefallen.",
    "js.bobs.002": "Fehler beim Speichern der Bob's 27 Stats:",

    // ── js.cricket ──────────────────────────────────────────────
    "js.cricket.001": "Beide Spieler haben denselben Namen!",
    "js.cricket.002": "Fehler beim Speichern der Cricket-Stats:",

    // ── js.gotcha ───────────────────────────────────────────────
    "js.gotcha.001": "Maximal 8 Spieler erlaubt!",
    "js.gotcha.002": "Dieser Spieler ist bereits in der Liste!",
    "js.gotcha.003": "Gotcha braucht mindestens 2 Spieler!",
    "js.gotcha.004": "Maximal 180 Punkte pro Aufnahme möglich!",

    // ── js.party ────────────────────────────────────────────────
    "js.party.001": "Bitte füge mindestens 1 Spieler hinzu!",
    "js.party.002": "Dart-für-Dart Eingabe",

    // ── js.random ───────────────────────────────────────────────
    "js.random.001": "Minimum darf nicht größer als Maximum sein!",
    "js.random.002": "Darts und Runden müssen mindestens 1 sein!",
    "js.random.003": "In diesem Bereich gibt es keine checkbare Zahl!",
    "js.random.004": "Fehler beim Speichern der Random-Stats:",

    // ── js.rtw ──────────────────────────────────────────────────
    "js.rtw.001": "Fehler beim Speichern der RTW-Stats:",

    // ── js.scoring ──────────────────────────────────────────────
    "js.scoring.001": "Trainings-Sitzung wirklich zurücksetzen?",
    "js.scoring.002": "Sitzung zurückgesetzt – neue Serie!",
    "js.scoring.003": "Noch keine Aufnahme – wirf los!",

    // ── js.secureonline ─────────────────────────────────────────
    "js.secureonline.001": "Teile den Code. Sobald der Gegner da ist, kannst du starten.",
    "js.secureonline.002": "Warte, bis der Host das Spiel startet.",
    "js.secureonline.003": "Kopieren nicht möglich.",
    "js.secureonline.004": "Sync-Fehler: ",
    "js.secureonline.005": "Der Host hat die Lobby geschlossen.",
    "js.secureonline.006": "Warte, ob der Host eine Revanche startet …",
    "js.secureonline.007": "Dieses Spiel läuft gerade nicht.",
    "js.secureonline.008": "Zuschauer-Modus: Du siehst das Spiel live.",
    "js.secureonline.009": "Keine offenen Lobbys oder laufenden Spiele.",

    // ── js.secure ───────────────────────────────────────────────
    "js.secure.001": "Bot hinzufügen",
    "js.secure.002": "Wie stark soll der Gegner sein?",
    "js.secure.004": "Bitte füge einen Spieler hinzu!",
    "js.secure.005": "Ein gewertetes Spiel benötigt mindestens 2 Teilnehmer!",
    "js.secure.006": "Fehler beim Speichern der Secure-History:",
    "js.secure.007": "Du hast 0 Punkte geworfen — Sichern nicht möglich.",
    "js.secure.008": "0 Punkte – kein Sichern möglich",
    "js.secure.009": "Nicht gesichert – 0 Punkte",

    // ── js.heatmap ──────────────────────────────────────────────
    "js.heatmap.001": " im gewählten Zeitraum",

    // ── js.profile ──────────────────────────────────────────────
    "js.profile.001": "Bitte logge dich ein, um dein Profil zu sehen.",
    "js.profile.002": "Ø Punkte / Spiel",
    "js.profile.003": "ENDSTAND DER LETZTEN DURCHGÄNGE",
    "js.profile.004": "Höchstes Level",
    "js.profile.005": "Ø Höchstlevel",
    "js.profile.006": "HÖCHSTES LEVEL JE DURCHGANG",
    "js.profile.007": "HÄUFIGSTE AUFNAHMEN",
    "js.profile.008": "LETZTE DURCHGÄNGE",

    // ── js.settings ─────────────────────────────────────────────
    "js.settings.001": "Einstellungen sind als Gast nicht verfügbar.",
    "js.settings.002": "Bei Google-Login nicht verfügbar",
    "js.settings.003": "Keine Änderungen vorgenommen.",
    "js.settings.004": "Bitte überprüfe deine neue E-Mail-Adresse für den Bestätigungslink.",
    "js.settings.005": "Fehler: Code konnte nicht erstellt werden.",

    // ── js.stats ────────────────────────────────────────────────
    "js.stats.001": "Noch keine 501-Daten für {name} vorhanden.",
    "js.stats.002": "Noch keine Secure-Daten für {name} vorhanden.",
    "js.stats.003": "Noch keine Bob's 27-Daten vorhanden.",
    "js.stats.004": "Noch keine RTW-Daten vorhanden.",
    "js.stats.005": "Lade Daten...",
    "js.stats.006": "Noch keine Spiele aufgezeichnet.",
    "js.stats.007": "Möchtest du dieses Match wirklich löschen? Die Statistiken werden korrigiert.",
    "js.stats.008": "Match gelöscht und Statistiken aktualisiert!",

    // ── js.stats501 ─────────────────────────────────────────────
    "js.stats501.001": "Finishes (Checkout-Höhe)",

    // ── js.ui ───────────────────────────────────────────────────
    "js.ui.001": "Menü schließen",
    "js.ui.002": "Menü öffnen",
    "js.ui.003": "ALS NÄCHSTES",
    "js.ui.004": "Bitte logge dich ein, um offene Lobbies zu sehen.",
    "js.ui.005": "Aktuell keine offenen Lobbies. Erstelle selbst eine – deine Freunde sehen sie sofort.",
    "js.ui.006": "Dieser Spieler hat noch keine Statistiken.",
    "js.ui.007": "Bitte gib zuerst deinen Namen ein!",
    "js.ui.008": "Fehler: Modal-HTML Elemente nicht gefunden!",
    "js.ui.009": "Bitte einen 6-stelligen Code eingeben.",

    // ── js.admin ────────────────────────────────────────────────
    "js.admin.001": "Erfolgreich gelöscht!",

    // ── js.einstseite ───────────────────────────────────────────
    "js.einstseite.001": "Session konnte nicht gelesen werden:",

    // ── js.kontakt ──────────────────────────────────────────────
    "js.kontakt.001": "Bitte gib eine gültige E-Mail-Adresse an.",
    "js.kontakt.002": "Spalte user_id fehlt - bitte supabase/contact_messages.sql ausführen.",
    "js.kontakt.003": "Senden fehlgeschlagen. Bitte später erneut versuchen.",

    // ── js.app ──────────────────────────────────────────────────
    "js.app.006": "Update verfügbar: {p1} (du hast {p2})",
    "js.app.007": "Tracker {p1} läuft – auf dem neuesten Stand",
    "js.app.008": "Alpha-Download für deinen PC (Windows){p1}{p2}",

    // ── js.autoscore ────────────────────────────────────────────
    "js.autoscore.007": "erwartet {p1}. Bitte Tracker oder Seite aktualisieren.",

    // ── js.g121 ─────────────────────────────────────────────────
    "js.g121.004": "{p1} gecheckt! Nächstes Level.",
    "js.g121.005": "Nicht geschafft! Zurück auf {p1}",

    // ── js.g501 ─────────────────────────────────────────────────
    "js.g501.019": "{p1} wirft...",
    "js.g501.020": "Ein Score von {p1} ist nicht möglich!",
    "js.g501.021": "{p1} ist eine Bogey-Zahl — mit einem Doppel nicht checkbar.",
    "js.g501.022": "{p1} hat das Spiel abgebrochen!",
    "js.g501.023": "{p1} gewinnt das Match!",
    "js.g501.024": "{p1} gewinnt das Leg!",
    "js.g501.025": "Bot wirft: {p1}...",

    // ── js.bobs ─────────────────────────────────────────────────
    "js.bobs.003": "{p1} wirft...",

    // ── js.cricket ──────────────────────────────────────────────
    "js.cricket.003": "{p1} wirft... ({p2}/{p3})",

    // ── js.gotcha ───────────────────────────────────────────────
    "js.gotcha.005": "Noch {p1} Punkte bis {p2}",
    "js.gotcha.006": "{p1} wirft...",
    "js.gotcha.007": "{p1}: Überworfen! ({p2})",
    "js.gotcha.008": "GOTCHA! {p1} fällt zurück auf 0!",

    // ── js.party ────────────────────────────────────────────────
    "js.party.003": "{p1}: Überworfen!",

    // ── js.random ───────────────────────────────────────────────
    "js.random.005": "Voreinstellung \"{p1}\" übernommen.",

    // ── js.rtw ──────────────────────────────────────────────────
    "js.rtw.002": "{p1} wirft...",

    // ── js.secure ───────────────────────────────────────────────
    "js.secure.010": "Maximal {p1} Spieler erlaubt!",
    "js.secure.011": "{p1}: {p2} Punkte",
    "js.secure.botnull": "{p1} trifft nicht — 0 Punkte",
    "js.secure.botpunkte": "{p1} holt {p2} Rohpunkte",
    "js.secure.botbulls": "BULLSEYE! ×{p1}",
    "js.secure.endetitel": "{p1} gewinnt!",
    "js.secure.enderevanche": "Revanche — nochmal spielen",
    "js.secure.endeschluss": "Spiel beenden",

    // ── Gemeinsamer Endbildschirm (endbildschirm.js, 29.08.2026) ─
    "ende.revanche": "Revanche",
    "ende.setup": "Setup ändern",
    "ende.heim": "Hauptmenü",
    "js.ende.sieg": "{p1} gewinnt!",
    "js.ende.fertig": "Spiel beendet",
    "js.ende.geschafft": "Geschafft!",
    "js.ende.punkte": "Punkte",

    // ── Spielwache (spielwache.js, 29.08.2026) ──────────────────
    "wache.laeuft": "Unterbrochenes Spiel",
    "wache.fortsetzen": "Fortsetzen",
    "wache.verwerfen": "Verwerfen",
    "js.wache.fehler": "Fortsetzen fehlgeschlagen – Spielstand verworfen.",

    // ── 501 Finish-Regel & Double-In (29.08.2026) ───────────────
    "501.finishLabel": "Finish",
    "501.finishDouble": "Double-Out (Standard)",
    "501.finishMaster": "Master-Out (Doppel oder Triple)",
    "501.finishStraight": "Straight-Out (jedes Feld)",
    "501.doubleInLabel": "Double-In",
    "501.doubleInText": "Zählen beginnt erst mit einem Doppel",
    "js.g501.doubleInOffen": "{p1}: erst mit Doppel einchecken – {p2} Punkte zählen nicht",
    "securegame.boardHinweis": "Aufs Board tippen – das Zielfeld leuchtet",

    // ── js.profile ──────────────────────────────────────────────
    "js.profile.009": "Keine Daten für {p1} bei diesem Spieler.",
    "js.profile.010": "Noch keine Daten für {p1}. Spiel eine Runde, dann erscheinen hier deine Zahlen.",
    "js.profile.011": "Noch keine Daten für {p1}.",

    // ── js.admin ────────────────────────────────────────────────
    "js.admin.002": "\"{p1}\" wirklich löschen?",

    // ── js.app ──────────────────────────────────────────────────
    "js.app.009": "Spieler",
    "js.app.010": "Alle Modi anzeigen",

    // ── js.autoscore ────────────────────────────────────────────
    "js.autoscore.008": "Kein Tracker verbunden — tippen zum Verbinden",
    "js.autoscore.009": "Warte auf den ersten Dart …",

    // ── js.camera ───────────────────────────────────────────────
    "js.camera.002": "LÄDT...",

    // ── js.friends ──────────────────────────────────────────────
    "js.friends.006": "Suche läuft...",
    "js.friends.007": "Anfrage an {p1} wurde gesendet!",
    "js.friends.008": "Fehler: {p1}",
    "js.friends.009": "Keine offenen Anfragen.",
    "js.friends.010": "{p1} hat abgelehnt.",
    "js.friends.011": "{p1} Darts",
    "js.friends.012": "Bestes Leg",
    "js.friends.013": "Siege",
    "js.friends.014": "Lade Statistiken…",
    "js.friends.015": "Noch keine Statistiken vorhanden.",

    // ── js.g501 ─────────────────────────────────────────────────
    "js.g501.026": "Gast ist beigetreten!",
    "js.g501.027": "Dein Wurf...",
    "js.g501.028": "Best of {p1} Legs",
    "js.g501.029": "Der Raum wurde geschlossen!",
    "js.g501.030": "Neues Leg gestartet!",
    "js.g501.031": "✅ {p1} wurde erfolgreich verifiziert!",

    // ── js.bobs ─────────────────────────────────────────────────
    "js.bobs.004": "Spiel gewonnen!",

    // ── js.cricket ──────────────────────────────────────────────
    "js.cricket.004": "Alle Felder zu — {p1} Darts!",

    // ── js.gotcha ───────────────────────────────────────────────
    "js.gotcha.009": "Noch {p1} bis {p2} – exakt treffen!",
    "js.gotcha.010": "{p1} gewinnt mit exakt {p2}!",

    // ── js.party ────────────────────────────────────────────────
    "js.party.004": "{p1} hat gewonnen!",

    // ── js.random ───────────────────────────────────────────────
    "js.random.006": "Runde {p1} / {p2}",
    "js.random.007": "Fertig! {p1} von {p2} gecheckt.",

    // ── js.secureonline ─────────────────────────────────────────
    "js.secureonline.010": "Dieser Raum ist bereits voll.",
    "js.secureonline.011": "Dieser Name ist schon vergeben.",
    "js.secureonline.012": "{p1} ist beigetreten",
    "js.secureonline.013": "Gegner",
    "js.secureonline.014": "👁 Zuschauer-Modus · {p1} ist am Zug",
    "js.secureonline.015": "{p1} ist am Zug...",
    "js.secureonline.016": "{p1} ist beigetreten!",
    "js.secureonline.017": "{p1} gewinnt mit {p2} Punkten!",
    "js.secureonline.018": "Revanche mit gleichen Spielern?",
    "js.secureonline.019": "Dein Gegner hat den Raum bereits verlassen.",
    "js.secureonline.020": "Gast hat verlassen",

    // ── js.secure ───────────────────────────────────────────────
    "js.secure.013": "Dein Gegner ist am Zug.",

    // ── js.heatmap ──────────────────────────────────────────────
    "js.heatmap.003": "Alle Modi",
    "js.heatmap.004": "Alle Ziele",
    "js.heatmap.005": "Ziel ",
    "js.heatmap.006": "Lade Würfe …",
    "js.heatmap.007": "Kein Wurf entspricht den Filtern.",

    // ── js.profile ──────────────────────────────────────────────
    "js.profile.013": "Profilbild von {p1}",
    "js.profile.014": "Legs gespielt",
    "js.profile.015": "Doppel-Quote",
    "js.profile.016": "Runden gesamt",
    "js.profile.017": "Solo-Läufe",
    "js.profile.018": "Bester Solo-Lauf",
    "js.profile.019": " Darts",
    "js.profile.020": "Ø Solo-Darts",
    "js.profile.021": "Durchgänge",
    "js.profile.022": "Beste Runde",
    "js.profile.023": "Ø Treffer",
    "js.profile.024": "Level geschafft",
    "js.profile.025": "Level verloren",
    "js.profile.026": "Level-Quote",
    "js.profile.027": "Ø Darts / Treffer",
    "js.profile.028": "Heatmap-Modul nicht geladen.",
    "js.profile.029": "gewonnen",
    "js.profile.030": "verloren",
    "js.profile.031": "Sieg",
    "js.profile.032": "{p1} Punkte{p2}",
    "js.profile.033": "{p1} Treffer · {p2}",

    // ── js.kontakt ──────────────────────────────────────────────
    "js.kontakt.004": "Die Nachricht ist zu kurz (mindestens 10 Zeichen).",

    // ── js.stats ────────────────────────────────────────────────
    "js.stats.009": "Legs Gespielt",
    "js.stats.010": "Legs Winrate%",
    "js.stats.011": "Ø Score",
    "js.stats.012": "Gespielte Runden",
    "js.stats.013": "Triple Modus",
    "js.stats.014": "Leg {p1}",
    "js.stats.015": "Keine Daten",
    "js.stats.016": "Keine Details verfügbar.",
    "js.stats.017": "Keine Daten vorhanden.",
    "js.stats.018": "Lade 501 Daten...",
    "js.stats.019": "Häufigkeit",

    // ── js.stats501 ─────────────────────────────────────────────
    "js.stats501.002": "Noch keine Daten",
    "js.stats501.003": "Lade erweiterte Statistiken …",
    "js.stats501.004": "Keine Matches im gewählten Zeitraum.",
    "js.stats501.005": "Darts gesamt",
    "js.stats501.006": "Aufnahmen",
    "js.stats501.007": "Darts je Tag",
    "js.stats501.008": "Average-Verlauf je Match",
    "js.stats501.009": "Scoring-Verteilung (Aufnahmen)",
    "js.stats501.010": "Siege / Niederlagen",
    "js.stats501.011": "Darts je gewonnenem Leg",
    "js.stats501.012": "Top 10 Legs",
    "js.stats501.013": "Darts",
    "js.stats501.014": "Auswertung auf die jüngsten {p1} Matches begrenzt.",

    // ── js.uikit ────────────────────────────────────────────────
    "js.uikit.001": "Noch nichts vorhanden.",

    // ── js.ui ───────────────────────────────────────────────────
    "js.ui.010": "{p1} Treffer",
    "js.ui.011": "Lade Lobbies...",

    // ── js.friends ──────────────────────────────────────────────
    "js.friends.016": "Keine Spieler gefunden.",
    "js.friends.017": "Keine anderen Spieler gefunden.",
    "js.friends.018": "Bitte logge dich ein, um deine Freunde zu sehen.",
    "js.friends.019": "Du hast noch keine Freunde hinzugefügt.",

    // ── js.profile ──────────────────────────────────────────────
    "js.profile.034": "Keine Runden-Details verf&uuml;gbar.",

    // ── js.stats ────────────────────────────────────────────────
    "js.stats.020": "Keine Runden-Details verfügbar.",

    // ── js.ui ───────────────────────────────────────────────────
    "js.ui.012": "Fehler beim Laden der Lobbies.",
    "js.ui.013": "Aktuell keine offenen Lobbies verfügbar.",

    // ── js.friends ──────────────────────────────────────────────
    "js.friends.herausforderung": "<b style=\"color:white;\">{p1}</b> fordert dich zu {p2} <span style=\"color:var(--accent)\">{p3}</span> heraus!",

    // ── js.heatmap ──────────────────────────────────────────────
    "js.heatmap.wurf1": "{p1}: {p2} Wurf",
    "js.heatmap.wurfN": "{p1}: {p2} Würfe",

    // ── js.profile ──────────────────────────────────────────────
    "js.profile.geschafft": " · geschafft",

    // ── js.app ──────────────────────────────────────────────────
    "js.app.011": "Active game found! Reconnecting...",
    "js.app.012": "Aktives Secure-Spiel gefunden! Reconnecting...",
    "js.app.013": "Weniger anzeigen",

    // ── js.auth ─────────────────────────────────────────────────
    "js.auth.019": "Google Login fehlgeschlagen: ",
    "js.auth.020": "Registrierung fehlgeschlagen: ",
    "js.auth.021": "Login fehlgeschlagen: ",
    "js.auth.022": "Dein Name",
    "js.auth.023": "Neues Passwort",
    "js.auth.024": "Mindestens 6 Zeichen.",
    "js.auth.025": "Passwort erfolgreich aktualisiert!",

    // ── js.autoscore ────────────────────────────────────────────
    "js.autoscore.010": "Tracker verbunden",
    "js.autoscore.011": "Verbinde …",
    "js.autoscore.012": " · korrigiert",
    "js.autoscore.013": "Finish! Pfeile ziehen.",
    "js.autoscore.014": "Verdacht: Hand am Board kurz vor diesem Wurf – Wurfbild prüfen.",

    // ── js.caller ───────────────────────────────────────────────
    "js.caller.001": "Caller-Einstellungen gespeichert.",

    // ── js.camera ───────────────────────────────────────────────
    "js.camera.003": "Host",
    "js.camera.004": "Wartet...",
    "js.camera.005": "Starte...",
    "js.camera.006": "Spiel gestartet!",
    "js.camera.007": "Profilbild aktualisiert!",

    // ── js.friends ──────────────────────────────────────────────
    "js.friends.020": "Login erforderlich",
    "js.friends.021": "Unbekannt",
    "js.friends.022": "Online",
    "js.friends.023": "Offline",
    "js.friends.024": "Freundschaftsanfrage angenommen!",
    "js.friends.025": "Freund wirklich entfernen?",
    "js.friends.026": "Eintrag entfernt.",
    "js.friends.027": "Herausforderung gesendet",
    "js.friends.028": "Annehmen",
    "js.friends.029": "Match Average",
    "js.friends.030": "First-9 Average",
    "js.friends.031": "Siegquote",
    "js.friends.032": "Highscore",
    "js.friends.033": "Secure-Quote",
    "js.friends.034": "{p1} online",
    "js.friends.035": "Herausforderung an {p1} gesendet!",
    "js.friends.036": "(Best of {p1})",

    // ── js.g121 ─────────────────────────────────────────────────
    "js.g121.006": "Bust",
    "js.g121.007": "Finish: {p1}",

    // ── js.g501 ─────────────────────────────────────────────────
    "js.g501.032": "Bot",
    "js.g501.033": "Sende...",
    "js.g501.034": "Stats gespeichert ✓",
    "js.g501.035": "Neues Match gestartet!",
    "js.g501.036": "Board",
    "js.g501.037": "Tastatur",
    "js.g501.038": "Bust ({p1})",
    "js.g501.039": "Score: {p1}",
    "js.g501.040": "[BOT] (Avg: {p1})",

    // ── js.bobs ─────────────────────────────────────────────────
    "js.bobs.005": "Spiel beendet.",

    // ── js.cricket ──────────────────────────────────────────────
    "js.cricket.005": "Unbekannte Variante!",
    "js.cricket.006": "{p1} gewinnt!",

    // ── js.random ───────────────────────────────────────────────
    "js.random.008": "Verfehlt",
    "js.random.009": "Weg: {p1}",

    // ── js.rtw ──────────────────────────────────────────────────
    "js.rtw.003": "Spiel abgeschlossen!",

    // ── js.secureonline ─────────────────────────────────────────
    "js.secureonline.021": "Lobby erstellt",
    "js.secureonline.022": "Beitritt fehlgeschlagen: ",
    "js.secureonline.023": "Code kopiert!",
    "js.secureonline.024": "Es fehlt noch ein Gegenspieler.",
    "js.secureonline.025": "Spiel gestartet",
    "js.secureonline.026": "Laufendes Secure-Spiel gefunden – wieder verbunden.",
    "js.secureonline.027": "Du bist dran",
    "js.secureonline.028": "Spiel beendet",
    "js.secureonline.029": "Revanche gestartet",
    "js.secureonline.030": "Revanche fehlgeschlagen: ",
    "js.secureonline.031": "Offene Lobbys",
    "js.secureonline.032": "Laufende Spiele · Zuschauen",
    "js.secureonline.033": "{p1} vs. {p2}",

    // ── js.secure ───────────────────────────────────────────────
    "js.secure.016": "verfehlt Bull...",
    "js.secure.017": "SICHERT!",
    "js.secure.018": "Offen",
    "js.secure.019": "{p1} × {p2}",
    "js.secure.020": "{p1} × ungesichert",

    // ── js.heatmap ──────────────────────────────────────────────
    "js.heatmap.008": "7 Tage",
    "js.heatmap.009": "30 Tage",
    "js.heatmap.010": "90 Tage",
    "js.heatmap.011": "Alles",
    "js.heatmap.012": "Training + Match",
    "js.heatmap.013": "Nur Training",
    "js.heatmap.014": "Nur Match",

    // ── js.obs ──────────────────────────────────────────────────
    "js.obs.001": "OBS-Einstellungen gespeichert.",

    // ── js.profile ──────────────────────────────────────────────
    "js.profile.035": "Highest Finish",
    "js.profile.036": "Busts",
    "js.profile.037": "Spiele",
    "js.profile.038": "Partien",
    "js.profile.039": "Durchgespielt",
    "js.profile.040": "Erfolgsquote",
    "js.profile.041": "Ø Endstand",
    "js.profile.042": "Letzter Stand",
    "js.profile.043": "Letzter Lauf",
    "js.profile.044": "Single",
    "js.profile.045": "Double",
    "js.profile.046": "Triple",
    "js.profile.047": "TREFFER JE DURCHGANG",
    "js.profile.048": "Sessions",
    "js.profile.049": "Versuche",
    "js.profile.050": "Getroffen",
    "js.profile.051": "Trefferquote",
    "js.profile.052": "Beste Session",
    "js.profile.053": "Ø PUNKTE PRO ZAHL",
    "js.profile.054": "Zur App",
    "js.profile.055": "MATCH-HISTORY",
    "js.profile.056": "Match-Sieg",
    "js.profile.057": "Match-Niederlage",
    "js.profile.058": "Niederlage",
    "js.profile.059": "Dabei seit {p1}",
    "js.profile.060": "Level {p1}",

    // ── js.settings ─────────────────────────────────────────────
    "js.settings.006": "Mindestens 6 Zeichen",
    "js.settings.007": "Das Passwort muss mindestens 6 Zeichen lang sein.",
    "js.settings.008": "Speichert...",
    "js.settings.009": "Einstellungen erfolgreich gespeichert!",
    "js.settings.010": "Du musst eingeloggt sein!",

    // ── js.setupkit ─────────────────────────────────────────────
    "js.setupkit.001": "Auswahl",

    // ── js.admin ────────────────────────────────────────────────
    "js.admin.003": "Falsches Passwort!",
    "js.admin.004": "Erfolgreich gespeichert!",

    // ── js.kontakt ──────────────────────────────────────────────
    "js.kontakt.005": "Wichtig",
    "js.kontakt.006": "Bug",
    "js.kontakt.007": "WIRD GESENDET...",
    "js.kontakt.008": "Nachricht gesendet. Danke!",
    "js.kontakt.009": "Allgemein",
    "js.kontakt.010": "Senden fehlgeschlagen: ",
    "js.kontakt.011": "Netzwerkfehler",
    "js.kontakt.012": "NACHRICHT SENDEN",

    // ── js.stats ────────────────────────────────────────────────
    "js.stats.021": "First-9 Avg",
    "js.stats.022": "Match Avg",
    "js.stats.023": "High Finish",
    "js.stats.024": "Winrate%",
    "js.stats.025": "Secure Rate",
    "js.stats.026": "Double Rate",
    "js.stats.027": "DURCHSCHNITT PRO ZAHL",
    "js.stats.028": "Letztes Spiel",
    "js.stats.029": "PUNKTEVERLAUF (LETZTE 20 SPIELE)",
    "js.stats.030": "Single Modus",
    "js.stats.031": "Double Modus",
    "js.stats.032": "Beliebig Modus",
    "js.stats.033": "TREFFERVERLAUF (LETZTE 20 SPIELE)",
    "js.stats.034": "Alle",
    "js.stats.035": "Wert",
    "js.stats.037": "Spiel {p1}",

    // ── js.stats501 ─────────────────────────────────────────────
    "js.stats501.015": "Matches",
    "js.stats501.016": "Bester Average",
    "js.stats501.017": "Bestes Finish",
    "js.stats501.018": "Checkout-Quote (gesamt)",
    "js.stats501.019": "Datum",
    "js.stats501.020": "Top 10 Finishes",
    "js.stats501.021": "Match-Average",
    "js.stats501.022": "First-9-Average",
    "js.stats501.023": "Niederlagen",

    // ── js.ui ───────────────────────────────────────────────────
    "js.ui.014": "AM ZUG",
    "js.ui.015": "501-Lobby erstellen",

    // ── js.secure ───────────────────────────────────────────────
    "js.secure.verifiziert": "{p1} erfolgreich verifiziert!",
    "js.secure.gesichert": "Gesichert (x{p1})",

    // ── js.stats ────────────────────────────────────────────────
    "js.stats.matchSieg": "Match-Sieg",
    "js.stats.matchNiederlage": "Match-Niederlage",
    "js.stats.gegen": "gegen",
    "js.stats.pktSuffix": " Pkt",
    "js.stats.ich": "Ich",

    // ── js.profile ──────────────────────────────────────────────
    "js.profile.trefferquoteSession": "TREFFERQUOTE JE SESSION (%)",

    // ── js.secure ───────────────────────────────────────────────

    // ── js.auth ─────────────────────────────────────────────────
    "js.auth.neuesPasswort": "Neues Passwort",

    // ── js.friends ──────────────────────────────────────────────
    "js.friends.anfrage1": "{p1} Anfrage",
    "js.friends.anfrageN": "{p1} Anfragen",

    // ── js.cricket ──────────────────────────────────────────────
    "js.cricket.gewinnt": "{p1} gewinnt!",

    // ── js.secureonline ─────────────────────────────────────────
    "js.secureonline.zuschauerEnde": "👁 Spiel beendet",
    "js.secureonline.zuschauen": "👁 Zuschauen",

    // ── js.caller ───────────────────────────────────────────────
    "js.caller.stimmeAuto": "Automatisch (deutsche Stimme)",

    // ── js.admin ────────────────────────────────────────────────
    "js.admin.datum": "Datum",
    "js.admin.name": "Name",
    "js.admin.email": "E-Mail",
    "js.admin.nachricht": "Nachricht",
    "js.admin.aktionen": "Aktionen",
    "js.admin.wert": "Wert",

    // ── js.g501 ─────────────────────────────────────────────────
    "js.g501.eingabeart": "{p1}-Eingabe",
  },
  en: {

    // ── Aufnahme-Eingabe (aufnahme-eingabe.js, 14.08.2026) ──────
    "aufnahme.treffer": "Hits",
    "aufnahme.rest": "Left",
    "aufnahme.ziel": "Target",
    "aufnahme.dartsUebrig": "{p1} of {p2} darts",
    "aufnahme.gecheckt": "Checked out with {p1} darts",
    "aufnahme.ueberworfen": "Bust",
    "aufnahme.nichtGeschafft": "Not checked",
    "aufnahme.korrekturHinweis": "Tap a detected dart to correct it",
    "aufnahme.korrekturFeld": "Pick the new field for dart {p1}",
    "party.bustDoppel": "{p1}: no double to finish – bust!",
    "gotcha.bustDoppel": "{p1}: target only with a double – bust!",
    "party.009": "Double out",
    "party.010": "Finish only on a double or bullseye",
    "gotcha.012": "Double out",
    "gotcha.013": "Target only on a double or bullseye",
    "bulloff.titel": "Bull-off",
    "einst.paketStandard": "Standard",
    "admin.offen": "Open",
    "admin.archiv": "Archive",
    "js.admin.erledigt": "Done",
    "js.admin.zurueckholen": "Reopen",
    "js.admin.archiviert": "Message archived",
    "js.admin.zurueckgeholt": "Message reopened",
    "js.admin.archivFehlt": "Archive unavailable – please run supabase/contact_messages_archiv.sql.",
    "bulloff.dran": "{p1} throws for the bull",
    "bulloff.wartet": "Waiting for {p1}…",
    "bulloff.fertig": "Decided",
    "bulloff.daneben": "missed",
    "bulloff.gleichstand": "Tie – throw again!",
    "bulloff.beginnt": "{p1} starts",
    "bulloff.abbrechen": "Start without bull-off",
    "501.bulloffLabel": "Bull-off",
    "501.bulloffText": "Closest to the bull throws first",
    "cricket.bulloffLabel": "Bull-off",
    "cricket.bulloffText": "Closest to the bull throws first",

    // ── caller ──────────────────────────────────────────────────
    "caller.bust": "Bust",
    "caller.gameShot": "Game shot",
    "caller.match": "Match",
    "caller.youRequire": "You require",

    // ── einst ───────────────────────────────────────────────────
    "einst.titel": "Settings",
    "einst.zurueck": "Back",
    "einst.konto": "Account",
    "einst.email": "Email address",
    "einst.passwort": "New password",
    "einst.passwortPlatzhalter": "At least 6 characters",
    "einst.speichern": "Save",
    "einst.darstellung": "Appearance",
    "einst.groesse": "Display size",
    "einst.akzent": "Accent colour",
    "einst.akzentHinweis": "Colours focus rings and active selections app-wide.",
    "einst.sprache": "Language",
    "einst.spracheHinweis": "Switches the interface. The caller speaks the language of its recordings.",
    "einst.geraet": "Pair a device",
    "einst.geraetHinweis": "Create a code to sign in as a guest on a friend's device. Your statistics are still saved.",
    "einst.pairing": "Create pairing code",
    "einst.caller": "Caller",
    "einst.callerHinweis": "Announces every counted visit. It plays your own recordings; a missing one is assembled from the others.",
    "einst.callerAn": "Enable caller",
    "einst.paket": "Voice pack",
    "einst.paketHinweis": "One voice is recorded so far. More will follow.",
    "einst.rueckfall": "Use system voice for missing recordings",
    "einst.systemstimme": "System voice (fallback only)",
    "einst.stimmeAuto": "Automatic",
    "einst.lautstaerke": "Volume",
    "einst.tempo": "Speech rate",
    "einst.wasAngesagt": "What gets announced",
    "einst.punkte": "Score thrown",
    "einst.rest": "Remaining from 170 instead of score (“you require 170”)",
    "einst.bust": "Bust",
    "einst.spielende": "Game shot and match",
    "einst.testen": "Test announcement",
    "einst.erweitert": "Advanced",
    "einst.streamer": "Streamer mode (area zoom)",
    "einst.wennDateiFehlt": "When a recording is missing",
    "einst.obs": "OBS streaming",
    "einst.obsHinweis": "Switches OBS (v28+) to a checkout scene as soon as <strong>you yourself</strong> are aiming at a field — an even remainder of 40 or less, or 50 for the bullseye. Your opponent's remainder does not count: they throw at their own board. OBS must run on the same machine.",
    "einst.obsAn": "Enable scene switching",
    "einst.port": "Port",
    "einst.obsPasswort": "Server password",
    "einst.obsPasswortPlatzhalter": "from the OBS WebSocket settings",
    "einst.szeneCheckout": "Checkout scene",
    "einst.szeneStandard": "Default scene",
    "einst.bereiche": "Streamer mode: scene per board area",
    "einst.bereicheHinweis": "Picks the scene holding the double being aimed at — D20 top, D3 bottom, bullseye centre. An empty field falls back to the checkout scene.",
    "einst.oben": "Top — 20, 1, 18, 12, 5",
    "einst.rechts": "Right — 4, 13, 6, 10, 15",
    "einst.unten": "Bottom — 2, 17, 3, 19, 7",
    "einst.links": "Left — 16, 8, 11, 14, 9",
    "einst.mitte": "Centre — bull and bullseye",
    "einst.gefahr": "Delete account",
    "einst.gefahrHinweis": "Removes your account and all statistics. This cannot be undone.",
    "einst.loeschen": "Delete account permanently",
    "einst.gespeichert": "Settings saved.",

    // ── datenschutz ─────────────────────────────────────────────
    "datenschutz.001": "Privacy Policy - Secure-Darts",
    "datenschutz.002": "Privacy Policy",
    "datenschutz.003": "1. Overview",
    "datenschutz.004": "This policy describes which personal data is processed when you use Secure-Darts, for what purpose and on what legal basis. Personal data is any data by which you can be personally identified.",
    "datenschutz.005": "Secure-Darts is a privately operated project under active development. The services used are listed individually below.",
    "datenschutz.006": "2. Controller",
    "datenschutz.007": "Patrick Bogdoll<br /> Reimanstraße 17<br /> 52070 Aachen<br /> Germany<br /> Email: info@secure-darts.com",
    "datenschutz.008": "The controller is the natural or legal person who alone or jointly with others determines the purposes and means of the processing of personal data.",
    "datenschutz.009": "3. Your rights",
    "datenschutz.010": "You have the right at any time to",
    "datenschutz.011": "<strong>information</strong> about the data stored about you, its origin, recipients and the purpose of processing (Art. 15 GDPR),",
    "datenschutz.012": "information",
    "datenschutz.013": "<strong>rectification</strong> of inaccurate data (Art. 16 GDPR),",
    "datenschutz.014": "rectification",
    "datenschutz.015": "<strong>erasure</strong> of your data (Art. 17 GDPR),",
    "datenschutz.016": "erasure",
    "datenschutz.017": "<strong>restriction of processing</strong> (Art. 18 GDPR),",
    "datenschutz.018": "restriction of processing",
    "datenschutz.019": "<strong>data portability</strong> – release of your data in a common, machine-readable format (Art. 20 GDPR),",
    "datenschutz.020": "data portability",
    "datenschutz.021": "<strong>withdrawal of consent given</strong> with effect for the future. The lawfulness of the processing carried out up to the withdrawal remains unaffected (Art. 7(3) GDPR).",
    "datenschutz.022": "withdrawal of consent given",
    "datenschutz.023": "An informal email to info@secure-darts.com is sufficient for all of these matters. You can also delete your account together with its statistics yourself in the settings.",
    "datenschutz.024": "Right to object (Art. 21 GDPR)",
    "datenschutz.025": "Where data is processed on the basis of legitimate interests pursuant to Art. 6(1)(f) GDPR, you have the right to object to this processing at any time on grounds relating to your particular situation. The relevant legal basis is stated for each service below. Following an objection, the data will no longer be processed unless there are compelling legitimate grounds which override your interests, or the processing serves to establish or defend legal claims.",
    "datenschutz.026": "Right to lodge a complaint with the supervisory authority (Art. 77 GDPR)",
    "datenschutz.027": "Irrespective of this, you have the right to lodge a complaint with a data protection supervisory authority, in particular in the member state of your residence, your place of work or the place of the alleged infringement. The authority responsible for the operator is:",
    "datenschutz.028": "Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen (State Commissioner for Data Protection and Freedom of Information of North Rhine-Westphalia)<br /> Kavalleriestraße 2–4, 40213 Düsseldorf<br /> <a href=\"https://www.ldi.nrw.de\">www.ldi.nrw.de</a>",
    "datenschutz.029": "www.ldi.nrw.de",
    "datenschutz.030": "4. Storage period",
    "datenschutz.031": "Unless a different period is stated below, the following applies: account data and game statistics are stored for as long as your account exists and are removed once it is deleted. Server log files kept by the hosting provider are deleted or anonymised after a short time in line with that provider's rules. Messages sent via the contact form are deleted as soon as the matter has been dealt with and no statutory retention obligations prevent this.",
    "datenschutz.032": "5. Data security",
    "datenschutz.033": "The connection to this website is encrypted throughout with TLS (recognisable by <em>https://</em> in the address bar). Passwords are never stored in plain text, but exclusively as a cryptographic hash held by the authentication service – not even the operator can view them.",
    "datenschutz.034": "https://",
    "datenschutz.035": "Your data is used exclusively for the purposes stated here. It is not sold, not rented out and not used for unsolicited advertising.",
    "datenschutz.036": "6. Accessing the website (hosting)",
    "datenschutz.037": "This website is hosted on GitHub Pages. The provider is GitHub, Inc., 88 Colin P Kelly Jr St, San Francisco, CA 94107, USA.",
    "datenschutz.038": "When the site is accessed, GitHub necessarily records connection data in server log files for technical reasons: IP address, browser type and version, operating system, referrer URL, host name and time of the request. This is necessary in order to deliver the page to your browser and to keep operations secure and stable. This data is not merged with other sources.",
    "datenschutz.039": "The legal basis is Art. 6(1)(f) GDPR – legitimate interest in providing the service reliably and securely. The transfer to the USA is based on the EU-US Data Privacy Framework and, in addition, on the European Commission's standard contractual clauses.",
    "datenschutz.040": "7. Account, login and game data (Supabase)",
    "datenschutz.041": "We use Supabase for registration, login and the storage of game scores. The provider is Supabase, Inc., 970 16th Street, San Francisco, CA 94107, USA. Data storage is configured to a European data centre.",
    "datenschutz.042": "The following are processed:",
    "datenschutz.043": "email address and password (only as a hash),",
    "datenschutz.044": "chosen user name and profile picture,",
    "datenschutz.045": "game statistics, match histories, friends list and lobby membership.",
    "datenschutz.046": "The legal basis is Art. 6(1)(b) GDPR – the processing is necessary in order to provide the game account. A data processing agreement pursuant to Art. 28 GDPR is in place with Supabase.",
    "datenschutz.047": "Data visible to other players",
    "datenschutz.048": "Secure-Darts is a multiplayer service. Your user name, your profile picture and your game results are visible to fellow players in shared games, in lobbies and – if you confirm a friendship – in their friends list. Choose a user name under which you would like to be recognised. A real name is not required.",
    "datenschutz.049": "8. Signing in with Google (single sign-on)",
    "datenschutz.050": "You can optionally sign in with your Google account. The provider is Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Ireland. You are then redirected to Google; after a successful sign-in we receive your email address and the name stored there in order to set up your account and recognise you again.",
    "datenschutz.051": "The legal basis is Art. 6(1)(b) GDPR. Use of this option is voluntary – registration with an email address and password is equally possible.",
    "datenschutz.052": "9. Contact form",
    "datenschutz.053": "Details submitted via the contact form – name, email address, category and message text – are stored in the database at Supabase so that the matter can be dealt with. If you are signed in, the message is assigned to your account.",
    "datenschutz.054": "Messages in urgent categories as well as messages from guests who are not signed in are additionally forwarded by email. This dispatch is handled by Formspree, Inc., USA. The data transmitted in this process is the name, email address, category and message text.",
    "datenschutz.055": "The legal basis is Art. 6(1)(b) GDPR where the enquiry relates to a contract, and otherwise Art. 6(1)(f) GDPR – legitimate interest in handling enquiries and error reports.",
    "datenschutz.056": "10. Profile pictures (DiceBear)",
    "datenschutz.057": "If you have not stored a profile picture of your own, an automatically generated avatar is loaded via the <em>api.dicebear.com</em> interface. Your browser establishes a connection to this service for that purpose, in the course of which your IP address is transmitted. Your user name is also passed on as the generation parameter.",
    "datenschutz.058": "api.dicebear.com",
    "datenschutz.059": "The legal basis is Art. 6(1)(f) GDPR – legitimate interest in a consistent presentation without operating our own image management.",
    // 060-064 (LiveKit) removed 20 Aug 2026 - the feature was taken out of
    // the app on 8 Aug 2026 (camera.js). Successors: 079-087 below.
    "datenschutz.065": "13. Storage on your device",
    "datenschutz.066": "We do not use any cookies for analysis or advertising purposes. Only your browser's local storage is used, namely for your login session, for details such as the current room code (so that a game in progress can be continued after a page reload), for display settings such as font size and language, for the random device identifier described in section 7 (error reports) and – if you use the tracker without being signed in – for a queue of up to 500 recognised throws (field and hit position, no images), which is only transferred into your statistics once you sign in.",
    "datenschutz.067": "This storage is strictly necessary for the service you have expressly requested and therefore does not require consent under § 25(2)(2) TDDDG (German Telecommunications Digital Services Data Protection Act). You can clear the local storage at any time via your browser settings; any game sessions in progress will be lost in the process.",
    "datenschutz.068": "14. References to external services",
    "datenschutz.069": "This page links to Discord, Instagram and TikTok. Following these links takes you away from Secure-Darts; from that point on, the privacy policies of the respective providers apply. No data is transmitted to these services before you click.",
    "datenschutz.070": "15. Changes to this policy",
    "datenschutz.071": "This policy will be amended as soon as changes to the application or to the services used make this necessary. The version available here at the time applies.",
    "datenschutz.072": "Last updated: August 2026",
    "datenschutz.073": "Throw data from the camera recognition (heat map)",
    "datenschutz.074": "If you use the local tracker (section 11), the app stores, for every recognised throw, the field hit and the hit position on the board in millimetres, together with the game mode and – in Secure mode – the target field. This throw data is assigned to your account and used for your own statistics, such as the hit heat map. Camera images are not part of it. Without an account, no throw data is transmitted to us; it waits solely in your browser's local storage until you sign in (section 13).",
    "datenschutz.075": "The legal basis is Art. 6(1)(b) GDPR – the processing is necessary to provide the statistics features of your account. The throw data is removed when your account is deleted.",
    "datenschutz.076": "Error reports (telemetry)",
    "datenschutz.077": "If a technical error occurs in the app, an error report is stored in the database at Supabase: the error text, the affected part of the program, the browser type and the screen that was open at the time. For signed-in users the report is assigned to their account; for guests it is assigned to a randomly generated device identifier instead (a random UUID in your browser's local storage, not a fingerprint), so that it remains recognisable whether several reports originate from the same device. The number of reports per session is limited to a handful of entries; game content and camera images are not included.",
    "datenschutz.078": "The legal basis is Art. 6(1)(f) GDPR – legitimate interest in a stable and error-free operation of the application.",
    "datenschutz.079": "11. Camera recognition: the Secure-Darts tracker (local software)",
    "datenschutz.080": "The tracker is a program that you install on your own computer. It analyses the images from the cameras mounted at your dartboard in order to recognise throws automatically. All image processing takes place exclusively locally on your computer – the camera images are transmitted neither to us nor to third parties. In detail:",
    "datenschutz.081": "The throw images (small image crops around the dart tip, shown in the app for each recognised dart) are created in memory, handed to your own browser over a local connection within your computer (127.0.0.1) and overwritten no later than with the next set of throws. They are not stored and never leave your device.",
    "datenschutz.082": "The optional recording feature (a switch in the tracker's status window, off by default) stores camera images of recognised throws exclusively in a folder on your own computer. Whether you keep, delete or pass on these files is entirely your decision.",
    "datenschutz.083": "The tracker's scoring log (recognised fields and your manual corrections, without images) is kept as a file on your own computer.",
    "datenschutz.084": "The tracker hands the recognised throws (field, points, hit position) to the web app over the local connection mentioned above; section 7 applies to the subsequent storage in your account, section 13 to the browser's local storage. This processing runs entirely on your device and under your control; this section is provided for transparency. Whether a newer tracker version is available is checked by the web app against a version file delivered with the website (section 6) – no additional data is transmitted in the process.",
    "datenschutz.085": "12. Downloading the tracker (Cloudflare R2)",
    "datenschutz.086": "The tracker's installation file is hosted by Cloudflare, Inc., 101 Townsend St, San Francisco, CA 94107, USA (R2 storage service). The download is currently available to participants of the closed test only: a server function at Supabase verifies your sign-in and your test authorisation and issues a short-lived, signed download address. When downloading, your IP address is transmitted to Cloudflare for technical reasons.",
    "datenschutz.087": "The legal basis is Art. 6(1)(b) GDPR – the provision of the software you requested. The transfer to the USA is based on the EU-US Data Privacy Framework and, in addition, on standard contractual clauses of the EU Commission.",

    // ── impressum ───────────────────────────────────────────────
    "impressum.001": "Legal Notice - Secure-Darts",
    "impressum.002": "Legal Notice",
    "impressum.003": "Information pursuant to § 5 DDG (German Digital Services Act)",
    "impressum.004": "Patrick Bogdoll<br /> Reimanstraße 17<br /> 52070 Aachen<br /> Germany",
    "impressum.005": "Contact",
    "impressum.006": "Telephone: +49 (0)15679 787304<br /> Email: info@secure-darts.com",
    "impressum.007": "Responsible for the content",
    "impressum.008": "Patrick Bogdoll, address as above.",
    "impressum.009": "Consumer dispute resolution",
    "impressum.010": "I am neither willing nor obliged to take part in dispute resolution proceedings before a consumer arbitration board.",
    "impressum.011": "Liability for content and links",
    "impressum.012": "The contents of these pages have been compiled with care. No guarantee can be given for their accuracy, completeness or topicality. This page contains links to external third-party websites over whose content we have no influence. The respective provider is always responsible for such third-party content. Should any legal infringements come to our attention, the links in question will be removed immediately.",
    "impressum.013": "Copyright",
    "impressum.014": "The content created by the operator, the source code and the design of this application are subject to German copyright law. Reproduction, editing, distribution and any kind of exploitation beyond the limits of copyright law require the written consent of the operator. The systematic extraction or copying of content, database structures or administration areas is not permitted. Likewise, the email address given here may not be used for unsolicited advertising, nor may the impression of an official connection to the operator be created.",
    "impressum.015": "Last updated: July 2026",

    // ── app ─────────────────────────────────────────────────────
    "app.001": "Welcome",
    "app.002": "Sign in to keep your statistics safe and available on every device.",
    "app.003": "Forgotten your password?",
    "app.004": "Sign in",
    "app.005": "Create account",
    "app.006": "Or",
    "app.007": "Continue as guest (local)",
    "app.008": "Legal notice",
    "app.009": "Privacy policy",
    "app.010": "Menu",
    "app.011": "Main menu",
    "app.012": "Open lobbies",
    "app.013": "Statistics",
    "app.014": "My profile",
    "app.015": "Legal notice",
    "app.016": "Privacy",
    "app.017": "Contact",
    "app.018": "Show beta notice",
    "app.019": "Friends",
    "app.020": "Search",
    "app.021": "My friends",
    "app.022": "Loading friends...",
    "app.023": "Choose your mode",
    "app.024": "Local or online multiplayer",
    "app.025": "Score securing, tactically",
    "app.026": "The absolute classic",
    "app.027": "Up to 8 players (local)",
    "app.028": "The double training",
    "app.029": "ROUND THE <span style=\"color: var(--accent)\">WORLD</span>",
    "app.030": "WORLD",
    "app.031": "Once around the whole board",
    "app.032": "Catch <span style=\"color: var(--accent)\">121</span>",
    "app.033": "Level by level, upwards",
    "app.034": "Cricket &<span style=\"color: var(--accent)\"> Tactics</span>",
    "app.035": "Tactics",
    "app.036": "Close numbers and score",
    "app.037": "<span style=\"color: var(--accent)\">RANDOM</span> CHECKOUT",
    "app.038": "RANDOM",
    "app.039": "Check a random number in X darts",
    "app.040": "GOT<span style=\"color: var(--accent)\">CHA</span>",
    "app.041": "Count up, steal points",
    "app.042": "SCORING <span style=\"color: var(--accent)\">TRAINING</span>",
    "app.043": "TRAINING",
    "app.044": "Throw open end, watch your average",
    "app.045": "Show all modes",
    "bot.stufe.neuling": "Rookie",
    "bot.stufe.anfaenger": "Beginner",
    "bot.stufe.hobby": "Hobby",
    "bot.stufe.freizeit": "Casual",
    "bot.stufe.verein": "Club player",
    "bot.stufe.liga": "League",
    "bot.stufe.ambitioniert": "Ambitious",
    "bot.stufe.profi": "Pro",
    "bot.stufe.halbprofi": "Semi-pro",
    "bot.stufe.weltklasse": "World class",
    "bot.stufe.nuke": "THE NUKE",
    "app.131": "Play",
    "app.132": "Head to head, local or online",
    "app.133": "Practice",
    "app.134": "Train alone or together",
    "app.046": "⬇ Tracker software",
    "app.047": "Closed alpha test – access via the contact form",
    "app.048": "Back",
    "app.049": "EDIT",
    "app.050": "Player",
    "app.051": "Change name",
    "app.052": "Open <span style=\"color: var(--accent)\">lobbies</span>",
    "app.053": "lobbies",
    "app.054": "Running 501 rooms you can join right away",
    "app.055": "Loading lobbies...",
    "app.056": "Refresh",
    "app.057": "Back to main menu",
    "app.058": "<b>Work in progress:</b> This is an active project. Please report bugs or wishes through our <a href=\"kontakt.html\">contact form</a> or on our <a href=\"https://discord.gg/B4A3MZGjBa\">Discord</a>.",
    "app.059": "Work in progress:",
    "app.060": "contact form",
    "app.061": "Discord",
    "app.062": "EDIT",
    "app.063": "501 stats",
    "app.064": "Secure stats",
    "app.065": "Bob's stats",
    "app.066": "RTW stats",
    "app.067": "Total",
    "app.068": "History",
    "app.069": "AVERAGE PER NUMBER",
    "app.070": "Bot setup",
    "app.071": "Choose the bot's target average:",
    "app.072": "Cancel",
    "app.073": "Ready to go!",
    "app.074": "Cancel game?",
    "app.075": "Your progress will be lost.",
    "app.076": "Yes, cancel",
    "app.077": "No, keep playing",
    "app.078": "Cancel",
    "app.079": "Careful!",
    "app.080": "Yes, confirm",
    "app.081": "Cancel",
    "app.082": "Player",
    "app.083": "Loading statistics…",
    "app.084": "Close",
    "app.085": "Statistics",
    "app.086": "Performance graph",
    "app.087": "Game settings",
    "app.088": "Mode:",
    "app.089": "301 darts",
    "app.090": "501 darts",
    "app.091": "701 darts",
    "app.092": "Length (best of):",
    "app.093": "1 leg",
    "app.094": "3 legs",
    "app.095": "5 legs",
    "app.096": "7 legs",
    "app.097": "9 legs",
    "app.098": "Challenge!",
    "app.099": "Cancel",
    "app.100": "Verify guest",
    "app.101": "Enter the player's 6-digit code:",
    "app.102": "Verify",
    "app.103": "Cancel",
    "app.104": "Correct throw",
    "app.105": "Single",
    "app.106": "Double",
    "app.107": "Treble",
    "app.108": "Cancel",
    "app.109": "Email address",
    "app.110": "Password (min. 6 characters)",
    "app.111": "Open menu",
    "app.112": "Settings",
    "app.113": "Open settings",
    "app.114": "Friends online",
    "app.115": "Search by player name...",
    "app.116": "Change profile picture",
    "app.117": "Average across all 501 games",
    "app.118": "Hide notice",
    "app.119": "Change profile picture",
    "app.120": "Open settings",
    "app.121": "Close",
    "app.122": "Close",

    // ── stats ───────────────────────────────────────────────────
    "stats.001": "Secure Darts – My Statistics",
    "stats.002": "MY STATISTICS",
    "stats.003": "Please log in to see your statistics.",
    "stats.004": "To login",
    "stats.005": "Total games",
    "stats.006": "Modes played",

    // ── kontakt ─────────────────────────────────────────────────
    "kontakt.001": "Contact - Secure-Darts",
    "kontakt.002": "CONTACT",
    "kontakt.003": "Got questions or feedback? Write to us directly.",
    "kontakt.004": "You are not logged in. You can still write to us — please provide your email address. <a href=\"/\" class=\"notice-link\">To login</a>",
    "kontakt.005": "To login",
    "kontakt.006": "Name (optional)",
    "kontakt.007": "Email *",
    "kontakt.008": "Category",
    "kontakt.009": "General enquiry",
    "kontakt.010": "Feedback / ideas",
    "kontakt.011": "Urgent matter",
    "kontakt.012": "Technical fault",
    "kontakt.013": "Message *",
    "kontakt.014": "SEND MESSAGE",
    "kontakt.015": "Your name",
    "kontakt.016": "you@example.com",
    "kontakt.017": "How can we help?",

    // ── admin ───────────────────────────────────────────────────
    "admin.001": "Secure-Darts Admin Panel",
    "admin.002": "Warning!",
    "admin.003": "DELETE PERMANENTLY",
    "admin.004": "CANCEL",
    "admin.005": "ADMIN LOGIN",
    "admin.006": "LOG IN",
    "admin.007": "BACK TO APP",
    "admin.008": "ADMIN PANEL",
    "admin.009": "MESSAGES",
    "admin.010": "EDIT DATA",
    "admin.011": "CANCEL",
    "admin.012": "SAVE",
    "admin.013": "Password",

    // ── 121game ─────────────────────────────────────────────────
    "121game.001": "Darts thrown",
    "121game.002": "Highest target",
    "121game.003": "Undo last throw",
    "121game.004": "Cancel game",
    "121game.005": "History",
    "121game.006": "Enter score...",

    // ── 121 ─────────────────────────────────────────────────────
    "121.001": "Catch <span style=\"color: var(--accent)\">121</span>",
    "121.002": "Check out the target in 9 darts. Manage it and you move up a number!",
    "121.003": "Target",
    "121.004": "Starting target",
    "121.005": "Safe points",
    "121.006": "every 5 numbers (e.g. 125, 130)",
    "121.007": "Players",
    "121.008": "Name",
    "121.009": "Player",
    "121.010": "Back",
    "121.011": "Start game",
    "121.012": "Your name...",

    // ── 501game ─────────────────────────────────────────────────
    "501game.001": "Game Shot!",
    "501game.002": "Start next leg",
    "501game.003": "New game (rematch)",
    "501game.004": "To main menu",
    "501game.005": "Remaining",
    "501game.006": "Recent visits",
    "501game.008": "No tracker connected",
    "501game.009": "Start the tracker and the throws will appear here.",
    "501game.010": "Total",
    "501game.011": "Miss",
    // Vokabular (29.08.2026), s. deutscher Block.
    "501game.012": "Confirm",
    "501game.013": "Single",
    "501game.014": "Double",
    "501game.015": "Treble",
    "501game.016": "MISS",
    "501game.017": "Undo last throw",
    "501game.018": "Cancel game",
    "501game.019": "Remaining",
    "501game.020": "Recent visits",

    // ── 501 ─────────────────────────────────────────────────────
    "501.001": "<span style=\"color: var(--accent)\">501</span> Darts",
    "501.002": "The absolute classic",
    "501.003": "Match",
    "501.004": "Starting score",
    "501.005": "Length",
    "501.006": "Best of 1",
    "501.007": "Best of 3",
    "501.008": "Best of 5",
    "501.009": "Best of 7",
    "501.010": "Best of 9",
    "501.011": "Mode",
    "501.012": "Local",
    "501.013": "Online",
    "501.014": "Local game",
    "501.015": "Player 1",
    "501.016": "Player 2",
    "501.017": "Statistics",
    "501.018": "Guest login",
    "501.019": "Start locally",
    "501.020": "Online lobby",
    "501.021": "Online name",
    "501.022": "Visibility",
    "501.023": "Public",
    "501.024": "Camera required",
    "501.025": "Room",
    "501.026": "Join",
    "501.027": "Host",
    "501.028": "Back",
    "501.029": "Online Lobby",
    "501.030": "Room code:",
    "501.031": "Host",
    "501.032": "Guest",
    "501.033": "Waiting...",
    "501.034": "Leave lobby",
    "501.035": "Your name",
    "501.036": "Player 2 / bot",
    "501.037": "Use bot",
    "501.038": "Your online name...",
    "501.039": "CODE",

    // ── bobsgame ────────────────────────────────────────────────
    "bobsgame.001": "Player",
    "bobsgame.002": "Score",
    "bobsgame.003": "Current target",
    "bobsgame.004": "How often did you hit the double?",
    "bobsgame.005": "Undo last throw",
    "bobsgame.006": "Cancel game",

    // ── bobs ────────────────────────────────────────────────────
    "bobs.001": "The ultimate double training",
    "bobs.002": "Rules",
    "bobs.003": "Easy Mode",
    "bobs.004": "No game over below 0",
    "bobs.005": "Starting score 27. Hit the given double. If you miss, the value is deducted. Drop below 0 and you are out.",
    "bobs.006": "Players",
    "bobs.007": "Name",
    "bobs.008": "Player",
    "bobs.009": "Back",
    "bobs.010": "Start game",
    "bobs.011": "Your name...",

    // ── cricketgame ─────────────────────────────────────────────
    "cricketgame.001": "Cancel game",
    "cricketgame.002": "Player 1",
    "cricketgame.003": "Player 2",
    "cricketgame.004": "Player 1 throwing... (0/3)",
    "cricketgame.005": "Single",
    "cricketgame.006": "Double",
    "cricketgame.007": "Treble",
    "cricketgame.008": "Miss",
    "cricketgame.009": "Confirm",
    "cricketgame.010": "Undo",
    "cricketgame.011": "Keyboard: 1/2/3 = multiplier · 0 = miss · Enter = confirm · Backspace = undo",

    // ── cricket ─────────────────────────────────────────────────
    "cricket.001": "Tactics",
    "cricket.002": "Hit each number 3x. After that you score as long as the opponent is still open.",
    "cricket.003": "Variant",
    "cricket.004": "Mode",
    "cricket.005": "Cricket 15 – Bull",
    "cricket.006": "Tactics 10 – Bull",
    "cricket.007": "Solo training",
    "cricket.008": "close numbers only, count darts",
    "cricket.009": "Players",
    "cricket.010": "Player 1",
    "cricket.011": "Player 2",
    "cricket.012": "Back",
    "cricket.013": "Start game",
    "cricket.014": "Player 1",
    "cricket.015": "Player 2",

    // ── gotchagame ──────────────────────────────────────────────
    "gotchagame.001": "Undo last visit",
    "gotchagame.002": "Cancel game",

    // ── gotcha ──────────────────────────────────────────────────
    "gotcha.001": "GOT<span style=\"color: var(--accent)\">CHA</span>",
    "gotcha.002": "Count up, hit exactly – and a tie knocks the opponent back to 0",
    "gotcha.003": "Game",
    "gotcha.004": "Target number",
    "gotcha.005": "Rules",
    "gotcha.006": "Everyone starts at 0 and counts up. Land exactly on another player's score and they drop back to 0 (\"Gotcha!\"). You only win on the exact target number – going over is a bust.",
    "gotcha.007": "Players (2–8)",
    "gotcha.008": "Add",
    "gotcha.009": "Back",
    "gotcha.010": "Start game",
    "gotcha.011": "Player name...",

    // ── partygame ───────────────────────────────────────────────
    "partygame.001": "SINGLE",
    "partygame.002": "DOUBLE",
    "partygame.003": "TREBLE",
    "partygame.004": "MISS",
    "partygame.005": "Undo last throw",
    "partygame.006": "Cancel game",

    // ── party ───────────────────────────────────────────────────
    "party.001": "Couch co-op for 2 to 8 players",
    "party.002": "Game",
    "party.003": "Starting score",
    "party.004": "Players",
    "party.005": "Add",
    "party.006": "Back",
    "party.007": "Start game",
    "party.008": "Player name...",

    // ── randomgame ──────────────────────────────────────────────
    "randomgame.001": "Player",
    "randomgame.002": "Finish",
    "randomgame.003": "Round 1 / 10",
    "randomgame.004": "Hit",
    "randomgame.005": "Rate",
    "randomgame.006": "Checked out with how many darts?",
    "randomgame.007": "Other number",
    "randomgame.008": "Undo",
    "randomgame.009": "Keyboard: 1..N = checked out with N darts · 0 = missed · Backspace = undo",

    // ── random ──────────────────────────────────────────────────
    "random.001": "<span style=\"color: var(--accent)\">Random</span> Checkout",
    "random.002": "Random",
    "random.003": "One random number, X darts of time. How often can you do it?",
    "random.004": "Numbers",
    "random.005": "Preset",
    "random.006": "Easy",
    "random.007": "Medium",
    "random.008": "Hard",
    "random.009": "Range",
    "random.010": "to",
    "random.011": "Repeats",
    "random.012": "Numbers may repeat",
    "random.013": "Round",
    "random.014": "Darts",
    "random.015": "Rounds",
    "random.016": "Players",
    "random.017": "Player",
    "random.018": "Back",
    "random.019": "Start game",
    "random.020": "Your name...",

    // ── rtwgame ─────────────────────────────────────────────────
    "rtwgame.001": "Player",
    "rtwgame.002": "Total score:",
    "rtwgame.003": "Current target",
    "rtwgame.004": "How often did you hit the target?",
    "rtwgame.005": "Undo last throw",
    "rtwgame.006": "Cancel game",

    // ── rtw ─────────────────────────────────────────────────────
    "rtw.001": "Round the <span style=\"color: var(--accent)\">World</span>",
    "rtw.002": "World",
    "rtw.003": "Once around the whole board",
    "rtw.004": "Game mode",
    "rtw.005": "Target mode",
    "rtw.006": "Single",
    "rtw.007": "Double",
    "rtw.008": "Treble",
    "rtw.009": "Any",
    "rtw.010": "Players",
    "rtw.011": "Name",
    "rtw.012": "Player",
    "rtw.013": "Back",
    "rtw.014": "Start game",
    "rtw.015": "Your name...",

    // ── scoring ─────────────────────────────────────────────────
    "scoring.001": "Scoring <span style=\"color: var(--accent)\">Training</span>",
    "scoring.002": "Training",
    "scoring.003": "Open end – just throw, the average runs along",
    "scoring.004": "3-dart average",
    "scoring.005": "Darts",
    "scoring.006": "Score",
    "scoring.007": "Best visit",
    "scoring.008": "180s",
    "scoring.009": "Recent visits",
    "scoring.010": "Undo last visit",
    "scoring.011": "Reset session",
    "scoring.012": "End training",
    "scoring.013": "Enter visit...",

    // ── securegame ──────────────────────────────────────────────
    "securegame.001": "STOP / CORRECTION",
    "securegame.002": "Player 1",
    "securegame.004": "Target",
    "securegame.005": "1 · Collect",
    "securegame.006": "2 · Secure",
    "securegame.007": "Open",
    "securegame.008": "0 × unsecured",
    "securegame.009": "Reset",
    "securegame.010": "✓ Confirm",
    "securegame.011": "↶ Undo last throw",
    "securegame.012": "Cancel game",
    "securegame.013": "Game over.",
    "securegame.014": "🔁 Rematch",
    "securegame.015": "Darts in phase 1",
    "securegame.016": "Darts in phase 2",

    // ── securelobby ─────────────────────────────────────────────
    "securelobby.001": "Online",
    "securelobby.002": "Room code",
    "securelobby.003": "Copy code",
    "securelobby.004": "Host",
    "securelobby.005": "Host",
    "securelobby.006": "Opponent",
    "securelobby.007": "Waiting...",
    "securelobby.008": "Start game",
    "securelobby.009": "Leave lobby",

    // ── securerules ─────────────────────────────────────────────
    "securerules.001": "Game rules",
    "securerules.002": "The aim is to collect the most points while working through the numbers from <b>1 to 20</b>, then <b>25</b> (single bull) and <b>50</b> (Bullseye).",
    "securerules.003": "1 to 20",
    "securerules.004": "<b>Short mode (10-Bull):</b> Same rules, but the ladder only starts at <b>10</b> – ideal for quick rounds. Selectable in the setup under \"Variant\".",
    "securerules.005": "Short mode (10-Bull):",
    "securerules.006": "1. Collecting points",
    "securerules.007": "In the first phase (3 darts) you throw at the current target number. You collect as many points as possible.",
    "securerules.008": "Single = single score",
    "securerules.009": "Double = double score",
    "securerules.010": "Treble = treble score",
    "securerules.011": "2. Securing",
    "securerules.012": "In the second phase (3 darts) you have to \"secure\" the points via the Bullseye.",
    "securerules.013": "<b>Single Bull (25):</b> The points are secured (x1).",
    "securerules.014": "Single Bull (25):",
    "securerules.015": "<b>Bullseye (50):</b> The points are secured and <b>doubled</b> (x2).",
    "securerules.016": "Bullseye (50):",
    "securerules.017": "doubled",
    "securerules.018": "<b>Nothing hit:</b> 0 points for this round.",
    "securerules.019": "Nothing hit:",
    "securerules.020": "Example: You hit the 20 three times (60 points).<br /> Then you hit Bullseye once.<br /> Result: 60 x 2 = <b>120 points</b>.",
    "securerules.021": "120 points",
    "securerules.022": "3. Global progress",
    "securerules.023": "All players throw at the same number. The number only goes up for everyone once <b>at least one player</b> has secured successfully in the round.",
    "securerules.024": "at least one player",
    "securerules.025": "4. Training mode",
    "securerules.026": "Tick the box in the setup. Your statistics are saved separately and do not count towards your official wins.",
    "securerules.027": "5. Bot opponents",
    "securerules.028": "Choose a bot in the setup. Bots are <b>not</b> saved in the statistics.",
    "securerules.029": "not",
    "securerules.030": "Back to setup",

    // ── securesetup ─────────────────────────────────────────────
    "securesetup.001": "Darts",
    "securesetup.002": "Tactical point securing",
    "securesetup.003": "Match",
    "securesetup.004": "Mode",
    "securesetup.005": "Local",
    "securesetup.006": "Online",
    "securesetup.007": "Local game",
    "securesetup.008": "Players",
    "securesetup.009": "More",
    "securesetup.010": "+ Bot",
    "securesetup.011": "Guest login",
    "securesetup.012": "Participants",
    "securesetup.013": "Variant",
    "securesetup.014": "Short mode (10 to Bull)",
    "securesetup.017": "Start",
    "securesetup.018": "Start locally",
    "securesetup.019": "Online lobby",
    "securesetup.020": "Online name",
    "securesetup.021": "Visibility",
    "securesetup.022": "Public",
    "securesetup.023": "Camera required",
    "securesetup.024": "Variant",
    "securesetup.025": "Short mode (10 to Bull, host decides)",
    "securesetup.026": "Room",
    "securesetup.027": "Join",
    "securesetup.028": "Host",
    "securesetup.029": "Open lobbies",
    "securesetup.030": "Refresh",
    "securesetup.031": "Back",
    "securesetup.032": "Game rules",
    "securesetup.033": "Type player name...",
    "securesetup.034": "Add player",
    "securesetup.035": "Your online name...",
    "securesetup.036": "CODE",

    // ── app ─────────────────────────────────────────────────────
    "app.123": "Name",
    "app.124": "Loading history...",
    "app.125": "Input",
    "app.126": "Do you really want to do this?",
    "app.127": "Me",
    "app.128": "Opponent",
    "app.129": "Me",
    "app.130": "Opponent",

    // ── admin ───────────────────────────────────────────────────
    "admin.014": "Do you really want to do this?",

    // ── einstellungen ───────────────────────────────────────────
    "einstellungen.001": "Secure Darts – Settings",
    "einstellungen.002": "You can change your name and profile picture in your profile.",
    "einstellungen.003": "A change has to be confirmed from both the old and the new address.",
    "einstellungen.004": "Leave empty to keep it unchanged.",
    "einstellungen.005": "When scoring automatically you stand at the oche and read from one or two metres away. Making it larger helps then.",
    "einstellungen.006": "Green (logo)",
    "einstellungen.007": "Blue (logo)",
    "einstellungen.008": "Red",
    "einstellungen.009": "Purple",
    "einstellungen.010": "Orange",
    "einstellungen.011": "Cyan",
    "einstellungen.012": "Pink",
    "einstellungen.013": "Lime",
    "einstellungen.014": "Deutsch",
    "einstellungen.015": "English",
    "einstellungen.017": "Your code",
    "einstellungen.018": "Enter this code on the main device (valid for 5 min):",
    "einstellungen.019": "Close",
    "einstellungen.020": "Careful!",
    "einstellungen.021": "Do you really want to do this?",
    "einstellungen.022": "Yes, confirm",
    "einstellungen.023": "Cancel",

    // ── 121game ─────────────────────────────────────────────────
    "121game.007": "Player",

    // ── 501game ─────────────────────────────────────────────────
    "501game.021": "Player wins!",
    "501game.022": "S1",
    "501game.023": "Best of 3 legs",
    "501game.024": "Player 1",
    "501game.025": "0 darts",
    "501game.026": "Player 2",
    "501game.027": "0 darts",
    "501game.028": "Question?",
    "501game.029": "S2",

    // ── 501 ─────────────────────────────────────────────────────
    "501.040": "Waiting...",
    "501.041": "Start game",

    // ── bobsgame ────────────────────────────────────────────────
    "bobsgame.007": "Player is throwing...",
    "bobsgame.008": "D1",

    // ── partygame ───────────────────────────────────────────────
    "partygame.007": "Dart-by-dart entry",

    // ── rtwgame ─────────────────────────────────────────────────
    "rtwgame.007": "Player is throwing...",

    // ── securegame ──────────────────────────────────────────────
    "securegame.017": "Bot playing...",

    // ── app ─────────────────────────────────────────────────────
    "app.zurueckApp": "BACK TO APP",
    "app.zurueck": "BACK",
    "app.meineStats": "View my statistics",

    // ── g121 ────────────────────────────────────────────────────
    "g121.ziel": "Target:",

    // ── 501game ─────────────────────────────────────────────────
    "501game.letzterWurf": "Last throw:",

    // ── recht ───────────────────────────────────────────────────
    "recht.hinweis": "This English text is a convenience translation. Only the German version of this page is legally binding.",

    // ── app ─────────────────────────────────────────────────────
    "app.googleLogin": "Sign in with Google",
    "app.anfragen": "Requests",
    "app.vergleichen": "Compare",
    "app.vergleich": "Comparison:",
    "app.gesamt": "Total:",
    "app.historie": "History",

    // ── 501game ─────────────────────────────────────────────────
    "501game.aufnahme": "Visit",

    // ── securegame ──────────────────────────────────────────────
    "securegame.rohpunkte": "Raw points:",
    "securegame.spielstand": "Current score",
    "securegame.pkt": "pts",

    // ── app ─────────────────────────────────────────────────────
    "app.herausfordernVor": "How do you want to play against",
    "app.herausfordernNach": "?",

    // ── js.app ──────────────────────────────────────────────────
    "js.app.001": "Player 1",
    "js.app.002": "Player 2",
    "js.app.003": "Closed alpha test – access via the contact form",
    "js.app.004": "no URL",
    "js.app.005": "Download not possible right now – please sign in again or try again later.",

    // ── js.auth ─────────────────────────────────────────────────
    "js.auth.001": "Please enter your email and password.",
    "js.auth.002": "We've sent you a confirmation email!",
    "js.auth.003": "You can't save a name as a guest.",
    "js.auth.004": "Change darts name",
    "js.auth.005": "This is how you appear in statistics and online games.",
    "js.auth.006": "This name is reserved for administrators.",
    "js.auth.007": "Error while saving: ",
    "js.auth.008": "Name changed to: ",
    "js.auth.009": "Please enter your email above to reset your password.",
    "js.auth.010": "Error: ",
    "js.auth.011": "Reset email has been sent!",
    "js.auth.012": "Password too short or cancelled. Please request the link again.",
    "js.auth.013": "Password could not be saved: ",
    "js.auth.014": "Do you really want to delete your account permanently? This cannot be undone!",
    "js.auth.015": "Deleting account...",
    "js.auth.016": "Your account has been deleted successfully.",
    "js.auth.017": "Error while deleting: ",
    "js.auth.018": "Delete account permanently",

    // ── js.autoscore ────────────────────────────────────────────
    "js.autoscore.001": "Auto-Scoring is running in another window",
    "js.autoscore.002": "BUST — visit recorded. Pull your darts.",
    "js.autoscore.003": "Start the Tracker, then the throws appear here.",
    "js.autoscore.004": "Throws are scored directly. Pull your darts — carry on.",
    "js.autoscore.005": "Tap to correct. Pulling your darts confirms the visit.",
    "js.autoscore.006": "Pull your darts — then it's confirmed.",

    // ── js.camera ───────────────────────────────────────────────
    "js.camera.001": "Your login session is invalid. Please log out once and log back in!",

    // ── js.friends ──────────────────────────────────────────────
    "js.friends.001": "You're already friends or there's already an open request.",
    "js.friends.002": "Error while sending: ",
    "js.friends.003": "Could not be accepted: ",
    "js.friends.004": "Deletion failed: ",
    "js.friends.005": "Lobby error: ",

    // ── js.g121 ─────────────────────────────────────────────────
    "js.g121.001": "Error while saving the 121 stats:",
    "js.g121.002": "Unexpected error while saving:",
    "js.g121.003": "Maximum 180 points per visit!",

    // ── js.g501 ─────────────────────────────────────────────────
    "js.g501.001": "Please enter your name!",
    "js.g501.002": "Please enter a room code!",
    "js.g501.003": "Room not found!",
    "js.g501.004": "The game is already running.",
    "js.g501.005": "Invalid input!",
    "js.g501.006": "Opponent is throwing...",
    "js.g501.007": "Not your turn — throw was not scored.",
    "js.g501.008": "Score must be between 0 and 180!",
    "js.g501.009": "Database error while sending: ",
    "js.g501.010": "Error!",
    "js.g501.011": "Error while processing the throw:",
    "js.g501.012": "Throw could not be processed!",
    "js.g501.013": "A player",
    "js.g501.014": "\n(Waiting for the host to start a rematch...)",
    "js.g501.015": "Stats could not be saved.",
    "js.g501.016": "Next leg starting...",
    "js.g501.017": "Undo no longer possible — your opponent has already thrown.",
    "js.g501.018": "Code invalid or expired.",

    // ── js.bobs ─────────────────────────────────────────────────
    "js.bobs.001": "Game Over! You've dropped below 0 points.",
    "js.bobs.002": "Error while saving the Bob's 27 stats:",

    // ── js.cricket ──────────────────────────────────────────────
    "js.cricket.001": "Both players have the same name!",
    "js.cricket.002": "Error while saving the Cricket stats:",

    // ── js.gotcha ───────────────────────────────────────────────
    "js.gotcha.001": "Maximum 8 players allowed!",
    "js.gotcha.002": "This player is already in the list!",
    "js.gotcha.003": "Gotcha needs at least 2 players!",
    "js.gotcha.004": "Maximum 180 points per visit!",

    // ── js.party ────────────────────────────────────────────────
    "js.party.001": "Please add at least 1 player!",
    "js.party.002": "Dart-by-dart entry",

    // ── js.random ───────────────────────────────────────────────
    "js.random.001": "Minimum must not be greater than maximum!",
    "js.random.002": "Darts and rounds must be at least 1!",
    "js.random.003": "There's no checkable number in this range!",
    "js.random.004": "Error while saving the Random stats:",

    // ── js.rtw ──────────────────────────────────────────────────
    "js.rtw.001": "Error while saving the RTW stats:",

    // ── js.scoring ──────────────────────────────────────────────
    "js.scoring.001": "Really reset the training session?",
    "js.scoring.002": "Session reset – new series!",
    "js.scoring.003": "No visit yet – start throwing!",

    // ── js.secureonline ─────────────────────────────────────────
    "js.secureonline.001": "Share the code. As soon as your opponent is here, you can start.",
    "js.secureonline.002": "Wait until the host starts the game.",
    "js.secureonline.003": "Copying not possible.",
    "js.secureonline.004": "Sync error: ",
    "js.secureonline.005": "The host has closed the lobby.",
    "js.secureonline.006": "Waiting to see whether the host starts a rematch …",
    "js.secureonline.007": "This game isn't running at the moment.",
    "js.secureonline.008": "Spectator mode: you're watching the game live.",
    "js.secureonline.009": "No open lobbies or running games.",

    // ── js.secure ───────────────────────────────────────────────
    "js.secure.001": "Add bot",
    "js.secure.002": "How strong should the opponent be?",
    "js.secure.004": "Please add a player!",
    "js.secure.005": "A ranked game needs at least 2 participants!",
    "js.secure.006": "Error while saving the Secure history:",
    "js.secure.007": "You scored 0 points — securing not possible.",
    "js.secure.008": "0 points – no securing possible",
    "js.secure.009": "Not secured – 0 points",

    // ── js.heatmap ──────────────────────────────────────────────
    "js.heatmap.001": " in the selected period",

    // ── js.profile ──────────────────────────────────────────────
    "js.profile.001": "Please log in to see your profile.",
    "js.profile.002": "Ø points / game",
    "js.profile.003": "FINAL SCORES OF THE LAST ROUNDS",
    "js.profile.004": "Highest level",
    "js.profile.005": "Ø highest level",
    "js.profile.006": "HIGHEST LEVEL PER ROUND",
    "js.profile.007": "MOST FREQUENT VISITS",
    "js.profile.008": "LAST ROUNDS",

    // ── js.settings ─────────────────────────────────────────────
    "js.settings.001": "Settings aren't available as a guest.",
    "js.settings.002": "Not available with Google login",
    "js.settings.003": "No changes made.",
    "js.settings.004": "Please check your new email address for the confirmation link.",
    "js.settings.005": "Error: code could not be created.",

    // ── js.stats ────────────────────────────────────────────────
    "js.stats.001": "No 501 data for {name} yet.",
    "js.stats.002": "No Secure data for {name} yet.",
    "js.stats.003": "No Bob's 27 data yet.",
    "js.stats.004": "No RTW data yet.",
    "js.stats.005": "Loading data...",
    "js.stats.006": "No games recorded yet.",
    "js.stats.007": "Do you really want to delete this match? The statistics will be corrected.",
    "js.stats.008": "Match deleted and statistics updated!",

    // ── js.stats501 ─────────────────────────────────────────────
    "js.stats501.001": "Finishes (checkout height)",

    // ── js.ui ───────────────────────────────────────────────────
    "js.ui.001": "Close menu",
    "js.ui.002": "Open menu",
    "js.ui.003": "UP NEXT",
    "js.ui.004": "Please log in to see open lobbies.",
    "js.ui.005": "No open lobbies at the moment. Create one yourself – your friends will see it straight away.",
    "js.ui.006": "This player has no statistics yet.",
    "js.ui.007": "Please enter your name first!",
    "js.ui.008": "Error: modal HTML elements not found!",
    "js.ui.009": "Please enter a 6-digit code.",

    // ── js.admin ────────────────────────────────────────────────
    "js.admin.001": "Deleted successfully!",

    // ── js.einstseite ───────────────────────────────────────────
    "js.einstseite.001": "Session could not be read:",

    // ── js.kontakt ──────────────────────────────────────────────
    "js.kontakt.001": "Please provide a valid email address.",
    "js.kontakt.002": "Column user_id is missing - please run supabase/contact_messages.sql.",
    "js.kontakt.003": "Sending failed. Please try again later.",

    // ── js.app ──────────────────────────────────────────────────
    "js.app.006": "Update available: {p1} (you have {p2})",
    "js.app.007": "Tracker {p1} running – up to date",
    "js.app.008": "Alpha download for your PC (Windows){p1}{p2}",

    // ── js.autoscore ────────────────────────────────────────────
    "js.autoscore.007": "expects {p1}. Please update the Tracker or refresh the page.",

    // ── js.g121 ─────────────────────────────────────────────────
    "js.g121.004": "{p1} checked out! Next level.",
    "js.g121.005": "Not done! Back to {p1}",

    // ── js.g501 ─────────────────────────────────────────────────
    "js.g501.019": "{p1} is throwing...",
    "js.g501.020": "A score of {p1} isn't possible!",
    "js.g501.021": "{p1} is a Bogey number — not checkable with a double.",
    "js.g501.022": "{p1} has quit the game!",
    "js.g501.023": "{p1} wins the match!",
    "js.g501.024": "{p1} wins the leg!",
    "js.g501.025": "Bot throws: {p1}...",

    // ── js.bobs ─────────────────────────────────────────────────
    "js.bobs.003": "{p1} is throwing...",

    // ── js.cricket ──────────────────────────────────────────────
    "js.cricket.003": "{p1} is throwing... ({p2}/{p3})",

    // ── js.gotcha ───────────────────────────────────────────────
    "js.gotcha.005": "{p1} points remaining to {p2}",
    "js.gotcha.006": "{p1} is throwing...",
    "js.gotcha.007": "{p1}: Bust! ({p2})",
    "js.gotcha.008": "GOTCHA! {p1} drops back to 0!",

    // ── js.party ────────────────────────────────────────────────
    "js.party.003": "{p1}: Bust!",

    // ── js.random ───────────────────────────────────────────────
    "js.random.005": "Preset \"{p1}\" applied.",

    // ── js.rtw ──────────────────────────────────────────────────
    "js.rtw.002": "{p1} is throwing...",

    // ── js.secure ───────────────────────────────────────────────
    "js.secure.010": "Maximum {p1} players allowed!",
    "js.secure.011": "{p1}: {p2} points",
    "js.secure.botnull": "{p1} misses — 0 points",
    "js.secure.botpunkte": "{p1} scores {p2} raw points",
    "js.secure.botbulls": "BULLSEYE! ×{p1}",
    "js.secure.endetitel": "{p1} wins!",
    "js.secure.enderevanche": "Rematch — play again",
    "js.secure.endeschluss": "End game",

    // ── Gemeinsamer Endbildschirm (endbildschirm.js, 29.08.2026) ─
    "ende.revanche": "Rematch",
    "ende.setup": "Change setup",
    "ende.heim": "Main menu",
    "js.ende.sieg": "{p1} wins!",
    "js.ende.fertig": "Game over",
    "js.ende.geschafft": "Done!",
    "js.ende.punkte": "Points",

    // ── Spielwache (spielwache.js, 29.08.2026) ──────────────────
    "wache.laeuft": "Interrupted game",
    "wache.fortsetzen": "Resume",
    "wache.verwerfen": "Discard",
    "js.wache.fehler": "Resume failed – saved game discarded.",

    // ── 501 Finish-Regel & Double-In (29.08.2026) ───────────────
    "501.finishLabel": "Finish",
    "501.finishDouble": "Double out (standard)",
    "501.finishMaster": "Master out (double or treble)",
    "501.finishStraight": "Straight out (any field)",
    "501.doubleInLabel": "Double in",
    "501.doubleInText": "Scoring starts with a double",
    "js.g501.doubleInOffen": "{p1}: check in with a double first – {p2} points don't count",
    "securegame.boardHinweis": "Tap the board – the target field lights up",

    // ── js.profile ──────────────────────────────────────────────
    "js.profile.009": "No data for {p1} for this player.",
    "js.profile.010": "No data for {p1} yet. Play a round and your numbers will appear here.",
    "js.profile.011": "No data for {p1} yet.",

    // ── js.admin ────────────────────────────────────────────────
    "js.admin.002": "Really delete \"{p1}\"?",

    // ── js.app ──────────────────────────────────────────────────
    "js.app.009": "Players",
    "js.app.010": "Show all modes",

    // ── js.autoscore ────────────────────────────────────────────
    "js.autoscore.008": "No Tracker connected — tap to connect",
    "js.autoscore.009": "Waiting for the first dart …",

    // ── js.camera ───────────────────────────────────────────────
    "js.camera.002": "LOADING...",

    // ── js.friends ──────────────────────────────────────────────
    "js.friends.006": "Searching...",
    "js.friends.007": "Request to {p1} has been sent!",
    "js.friends.008": "Error: {p1}",
    "js.friends.009": "No open requests.",
    "js.friends.010": "{p1} declined.",
    "js.friends.011": "{p1} darts",
    "js.friends.012": "Best leg",
    "js.friends.013": "Wins",
    "js.friends.014": "Loading statistics…",
    "js.friends.015": "No statistics yet.",

    // ── js.g501 ─────────────────────────────────────────────────
    "js.g501.026": "Guest has joined!",
    "js.g501.027": "Your throw...",
    "js.g501.028": "Best of {p1} legs",
    "js.g501.029": "The room has been closed!",
    "js.g501.030": "New leg started!",
    "js.g501.031": "✅ {p1} has been verified successfully!",

    // ── js.bobs ─────────────────────────────────────────────────
    "js.bobs.004": "Game won!",

    // ── js.cricket ──────────────────────────────────────────────
    "js.cricket.004": "All numbers closed — {p1} darts!",

    // ── js.gotcha ───────────────────────────────────────────────
    "js.gotcha.009": "{p1} remaining to {p2} – hit it exactly!",
    "js.gotcha.010": "{p1} wins with exactly {p2}!",

    // ── js.party ────────────────────────────────────────────────
    "js.party.004": "{p1} has won!",

    // ── js.random ───────────────────────────────────────────────
    "js.random.006": "Round {p1} / {p2}",
    "js.random.007": "Done! {p1} of {p2} checked out.",

    // ── js.secureonline ─────────────────────────────────────────
    "js.secureonline.010": "This room is already full.",
    "js.secureonline.011": "This name is already taken.",
    "js.secureonline.012": "{p1} has joined",
    "js.secureonline.013": "Opponent",
    "js.secureonline.014": "👁 Spectator mode · {p1} to throw",
    "js.secureonline.015": "{p1} is to throw...",
    "js.secureonline.016": "{p1} has joined!",
    "js.secureonline.017": "{p1} wins with {p2} points!",
    "js.secureonline.018": "Rematch with the same players?",
    "js.secureonline.019": "Your opponent has already left the room.",
    "js.secureonline.020": "Guest has left",

    // ── js.secure ───────────────────────────────────────────────
    "js.secure.013": "It's your opponent's turn.",

    // ── js.heatmap ──────────────────────────────────────────────
    "js.heatmap.003": "All modes",
    "js.heatmap.004": "All targets",
    "js.heatmap.005": "Target ",
    "js.heatmap.006": "Loading throws …",
    "js.heatmap.007": "No throw matches the filters.",

    // ── js.profile ──────────────────────────────────────────────
    "js.profile.013": "Profile picture of {p1}",
    "js.profile.014": "Legs played",
    "js.profile.015": "Double rate",
    "js.profile.016": "Total rounds",
    "js.profile.017": "Solo runs",
    "js.profile.018": "Best solo run",
    "js.profile.019": " darts",
    "js.profile.020": "Ø solo darts",
    "js.profile.021": "Rounds",
    "js.profile.022": "Best round",
    "js.profile.023": "Ø hits",
    "js.profile.024": "Levels completed",
    "js.profile.025": "Levels lost",
    "js.profile.026": "Level rate",
    "js.profile.027": "Ø darts / hit",
    "js.profile.028": "Heatmap module not loaded.",
    "js.profile.029": "won",
    "js.profile.030": "lost",
    "js.profile.031": "Win",
    "js.profile.032": "{p1} points{p2}",
    "js.profile.033": "{p1} hits · {p2}",

    // ── js.kontakt ──────────────────────────────────────────────
    "js.kontakt.004": "The message is too short (at least 10 characters).",

    // ── js.stats ────────────────────────────────────────────────
    "js.stats.009": "Legs Played",
    "js.stats.010": "Legs Winrate%",
    "js.stats.011": "Ø Score",
    "js.stats.012": "Rounds played",
    "js.stats.013": "Treble mode",
    "js.stats.014": "Leg {p1}",
    "js.stats.015": "No data",
    "js.stats.016": "No details available.",
    "js.stats.017": "No data available.",
    "js.stats.018": "Loading 501 data...",
    "js.stats.019": "Frequency",

    // ── js.stats501 ─────────────────────────────────────────────
    "js.stats501.002": "No data yet",
    "js.stats501.003": "Loading advanced statistics …",
    "js.stats501.004": "No matches in the selected period.",
    "js.stats501.005": "Total darts",
    "js.stats501.006": "Visits",
    "js.stats501.007": "Darts per day",
    "js.stats501.008": "Average trend per match",
    "js.stats501.009": "Scoring distribution (visits)",
    "js.stats501.010": "Wins / losses",
    "js.stats501.011": "Darts per leg won",
    "js.stats501.012": "Top 10 legs",
    "js.stats501.013": "Darts",
    "js.stats501.014": "Analysis limited to the most recent {p1} matches.",

    // ── js.uikit ────────────────────────────────────────────────
    "js.uikit.001": "Nothing here yet.",

    // ── js.ui ───────────────────────────────────────────────────
    "js.ui.010": "{p1} hits",
    "js.ui.011": "Loading lobbies...",

    // ── js.friends ──────────────────────────────────────────────
    "js.friends.016": "No players found.",
    "js.friends.017": "No other players found.",
    "js.friends.018": "Please log in to see your friends.",
    "js.friends.019": "You haven't added any friends yet.",

    // ── js.profile ──────────────────────────────────────────────
    "js.profile.034": "No round details available.",

    // ── js.stats ────────────────────────────────────────────────
    "js.stats.020": "No round details available.",

    // ── js.ui ───────────────────────────────────────────────────
    "js.ui.012": "Error while loading the lobbies.",
    "js.ui.013": "No open lobbies available at the moment.",

    // ── js.friends ──────────────────────────────────────────────
    "js.friends.herausforderung": "<b style=\"color:white;\">{p1}</b> challenges you to {p2} <span style=\"color:var(--accent)\">{p3}</span>!",

    // ── js.heatmap ──────────────────────────────────────────────
    "js.heatmap.wurf1": "{p1}: {p2} throw",
    "js.heatmap.wurfN": "{p1}: {p2} throws",

    // ── js.profile ──────────────────────────────────────────────
    "js.profile.geschafft": " · done",

    // ── js.app ──────────────────────────────────────────────────
    "js.app.011": "Active game found! Reconnecting...",
    "js.app.012": "Active Secure game found! Reconnecting...",
    "js.app.013": "Show less",

    // ── js.auth ─────────────────────────────────────────────────
    "js.auth.019": "Google sign-in failed: ",
    "js.auth.020": "Registration failed: ",
    "js.auth.021": "Login failed: ",
    "js.auth.022": "Your name",
    "js.auth.023": "New password",
    "js.auth.024": "At least 6 characters.",
    "js.auth.025": "Password updated successfully!",

    // ── js.autoscore ────────────────────────────────────────────
    "js.autoscore.010": "Tracker connected",
    "js.autoscore.011": "Connecting …",
    "js.autoscore.012": " · corrected",
    "js.autoscore.013": "Finish! Remove darts.",
    "js.autoscore.014": "Suspicion: hand at the board just before this throw – check the throw image.",

    // ── js.caller ───────────────────────────────────────────────
    "js.caller.001": "Caller settings saved.",

    // ── js.camera ───────────────────────────────────────────────
    "js.camera.003": "Host",
    "js.camera.004": "Waiting...",
    "js.camera.005": "Starting...",
    "js.camera.006": "Game started!",
    "js.camera.007": "Profile picture updated!",

    // ── js.friends ──────────────────────────────────────────────
    "js.friends.020": "Login required",
    "js.friends.021": "Unknown",
    "js.friends.022": "Online",
    "js.friends.023": "Offline",
    "js.friends.024": "Friend request accepted!",
    "js.friends.025": "Really remove friend?",
    "js.friends.026": "Entry removed.",
    "js.friends.027": "Challenge sent",
    "js.friends.028": "Accept",
    "js.friends.029": "Match Average",
    "js.friends.030": "First-9 Average",
    "js.friends.031": "Win rate",
    "js.friends.032": "Highscore",
    "js.friends.033": "Secure rate",
    "js.friends.034": "{p1} online",
    "js.friends.035": "Challenge sent to {p1}!",
    "js.friends.036": "(Best of {p1})",

    // ── js.g121 ─────────────────────────────────────────────────
    "js.g121.006": "Bust",
    "js.g121.007": "Finish: {p1}",

    // ── js.g501 ─────────────────────────────────────────────────
    "js.g501.032": "Bot",
    "js.g501.033": "Sending...",
    "js.g501.034": "Stats saved ✓",
    "js.g501.035": "New match started!",
    "js.g501.036": "Board",
    "js.g501.037": "Keyboard",
    "js.g501.038": "Bust ({p1})",
    "js.g501.039": "Score: {p1}",
    "js.g501.040": "[BOT] (Avg: {p1})",

    // ── js.bobs ─────────────────────────────────────────────────
    "js.bobs.005": "Game over.",

    // ── js.cricket ──────────────────────────────────────────────
    "js.cricket.005": "Unknown variant!",
    "js.cricket.006": "{p1} wins!",

    // ── js.random ───────────────────────────────────────────────
    "js.random.008": "Missed",
    "js.random.009": "Path: {p1}",

    // ── js.rtw ──────────────────────────────────────────────────
    "js.rtw.003": "Game completed!",

    // ── js.secureonline ─────────────────────────────────────────
    "js.secureonline.021": "Lobby created",
    "js.secureonline.022": "Joining failed: ",
    "js.secureonline.023": "Code copied!",
    "js.secureonline.024": "Still waiting for an opponent.",
    "js.secureonline.025": "Game started",
    "js.secureonline.026": "Ongoing Secure game found – reconnected.",
    "js.secureonline.027": "Your turn",
    "js.secureonline.028": "Game over",
    "js.secureonline.029": "Rematch started",
    "js.secureonline.030": "Rematch failed: ",
    "js.secureonline.031": "Open lobbies",
    "js.secureonline.032": "Ongoing games · Watch",
    "js.secureonline.033": "{p1} vs. {p2}",

    // ── js.secure ───────────────────────────────────────────────
    "js.secure.016": "misses the bull...",
    "js.secure.017": "SECURES!",
    "js.secure.018": "Open",
    "js.secure.019": "{p1} × {p2}",
    "js.secure.020": "{p1} × unsecured",

    // ── js.heatmap ──────────────────────────────────────────────
    "js.heatmap.008": "7 days",
    "js.heatmap.009": "30 days",
    "js.heatmap.010": "90 days",
    "js.heatmap.011": "All time",
    "js.heatmap.012": "Training + Match",
    "js.heatmap.013": "Training only",
    "js.heatmap.014": "Match only",

    // ── js.obs ──────────────────────────────────────────────────
    "js.obs.001": "OBS settings saved.",

    // ── js.profile ──────────────────────────────────────────────
    "js.profile.035": "Highest Finish",
    "js.profile.036": "Busts",
    "js.profile.037": "Games",
    "js.profile.038": "Games",
    "js.profile.039": "Completed",
    "js.profile.040": "Success rate",
    "js.profile.041": "Ø Final score",
    "js.profile.042": "Last score",
    "js.profile.043": "Last run",
    "js.profile.044": "Single",
    "js.profile.045": "Double",
    "js.profile.046": "Triple",
    "js.profile.047": "HITS PER ROUND",
    "js.profile.048": "Sessions",
    "js.profile.049": "Attempts",
    "js.profile.050": "Hit",
    "js.profile.051": "Hit rate",
    "js.profile.052": "Best session",
    "js.profile.053": "Ø POINTS PER NUMBER",
    "js.profile.054": "Go to app",
    "js.profile.055": "MATCH HISTORY",
    "js.profile.056": "Match win",
    "js.profile.057": "Match loss",
    "js.profile.058": "Loss",
    "js.profile.059": "Member since {p1}",
    "js.profile.060": "Level {p1}",

    // ── js.settings ─────────────────────────────────────────────
    "js.settings.006": "At least 6 characters",
    "js.settings.007": "The password must be at least 6 characters long.",
    "js.settings.008": "Saving...",
    "js.settings.009": "Settings saved successfully!",
    "js.settings.010": "You must be logged in!",

    // ── js.setupkit ─────────────────────────────────────────────
    "js.setupkit.001": "Selection",

    // ── js.admin ────────────────────────────────────────────────
    "js.admin.003": "Wrong password!",
    "js.admin.004": "Saved successfully!",

    // ── js.kontakt ──────────────────────────────────────────────
    "js.kontakt.005": "Important",
    "js.kontakt.006": "Bug",
    "js.kontakt.007": "SENDING...",
    "js.kontakt.008": "Message sent. Thank you!",
    "js.kontakt.009": "General",
    "js.kontakt.010": "Sending failed: ",
    "js.kontakt.011": "Network error",
    "js.kontakt.012": "SEND MESSAGE",

    // ── js.stats ────────────────────────────────────────────────
    "js.stats.021": "First-9 Avg",
    "js.stats.022": "Match Avg",
    "js.stats.023": "High Finish",
    "js.stats.024": "Winrate%",
    "js.stats.025": "Secure Rate",
    "js.stats.026": "Double Rate",
    "js.stats.027": "AVERAGE PER NUMBER",
    "js.stats.028": "Last game",
    "js.stats.029": "SCORE HISTORY (LAST 20 GAMES)",
    "js.stats.030": "Single mode",
    "js.stats.031": "Double mode",
    "js.stats.032": "Any mode",
    "js.stats.033": "HIT HISTORY (LAST 20 GAMES)",
    "js.stats.034": "All",
    "js.stats.035": "Value",
    "js.stats.037": "Game {p1}",

    // ── js.stats501 ─────────────────────────────────────────────
    "js.stats501.015": "Matches",
    "js.stats501.016": "Best average",
    "js.stats501.017": "Best finish",
    "js.stats501.018": "Checkout rate (total)",
    "js.stats501.019": "Date",
    "js.stats501.020": "Top 10 Finishes",
    "js.stats501.021": "Match Average",
    "js.stats501.022": "First-9 Average",
    "js.stats501.023": "Losses",

    // ── js.ui ───────────────────────────────────────────────────
    "js.ui.014": "TO THROW",
    "js.ui.015": "Create 501 lobby",

    // ── js.secure ───────────────────────────────────────────────
    "js.secure.verifiziert": "{p1} verified successfully!",
    "js.secure.gesichert": "Secured (x{p1})",

    // ── js.stats ────────────────────────────────────────────────
    "js.stats.matchSieg": "Match win",
    "js.stats.matchNiederlage": "Match loss",
    "js.stats.gegen": "vs",
    "js.stats.pktSuffix": " pts",
    "js.stats.ich": "Me",

    // ── js.profile ──────────────────────────────────────────────
    "js.profile.trefferquoteSession": "HIT RATE PER SESSION (%)",

    // ── js.secure ───────────────────────────────────────────────

    // ── js.auth ─────────────────────────────────────────────────
    "js.auth.neuesPasswort": "New password",

    // ── js.friends ──────────────────────────────────────────────
    "js.friends.anfrage1": "{p1} request",
    "js.friends.anfrageN": "{p1} requests",

    // ── js.cricket ──────────────────────────────────────────────
    "js.cricket.gewinnt": "{p1} wins!",

    // ── js.secureonline ─────────────────────────────────────────
    "js.secureonline.zuschauerEnde": "👁 Game over",
    "js.secureonline.zuschauen": "👁 Watch",

    // ── js.caller ───────────────────────────────────────────────
    "js.caller.stimmeAuto": "Automatic (German voice)",

    // ── js.admin ────────────────────────────────────────────────
    "js.admin.datum": "Date",
    "js.admin.name": "Name",
    "js.admin.email": "E-mail",
    "js.admin.nachricht": "Message",
    "js.admin.aktionen": "Actions",
    "js.admin.wert": "Value",

    // ── js.g501 ─────────────────────────────────────────────────
    "js.g501.eingabeart": "{p1} input",
  },
};

export default TEXTE;
export { TEXTE };
